if (!customElements.get('cm-pickmix')) {

  const normaliser = (v) =>
    (v || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const motsDe = (texte) => normaliser(texte).replace(/[^a-z0-9]+/g, ' ').trim();

  const grammesDans = (texte) => {
    const m = String(texte || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    if (!m) return 0;
    const valeur = parseFloat(m[1].replace(',', '.'));
    return Math.round(m[2].toLowerCase() === 'kg' ? valeur * 1000 : valeur);
  };

  const melanger = (liste) => {
    const copie = liste.slice();
    for (let i = copie.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copie[i], copie[j]] = [copie[j], copie[i]];
    }
    return copie;
  };

  const pluriel = (n, un, plusieurs) => n + ' ' + (n > 1 ? plusieurs : un);

  const poidsLisible = (grammes) =>
    grammes >= 1000
      ? (grammes / 1000).toLocaleString('fr-FR', { maximumFractionDigits: 1 }) + ' kg'
      : grammes + ' g';

  const QUANTITE_MAX = 10;

  const VOL_MIN = 276;
  const VOL_MAX_MS = 713;
  const VOL_BASE = 195;
  const VOL_PENTE = 0.391;
  const VOL_RECOUVRE = 70;
  const VOL_MAX = 14;
  let volsEnCours = 0;

  const prixMultiplie = (prixFormate, centimes, quantite) => {
    const virgule = /\d,\d{2}(?!\d)/.test(prixFormate);
    const montant = ((centimes * quantite) / 100).toFixed(2).replace('.', virgule ? ',' : '.');
    return prixFormate.replace(/\d[\d\s.,]*\d|\d/, montant);
  };

  const element = (balise, classe, texte) => {
    const el = document.createElement(balise);
    if (classe) el.className = classe;
    if (texte !== undefined) el.textContent = texte;
    return el;
  };

  const ICONE_OEIL =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="2"/>' +
    '<circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/></svg>';

  const PLATEAU_R = 92;
  const PLATEAU_PUITS = 0.31;
  const PLATEAU_ECART = 3.6;
  let plateauNo = 0;

  const geoPlateau = (cases) => {
    const n = Math.max(2, Math.min(24, Math.round(Number(cases) || 9)));
    const q = n - 1;
    const R = PLATEAU_R;
    const rd = R * PLATEAU_PUITS;
    const pas = 360 / q;
    const rad = (a) => (a * Math.PI) / 180;
    const n4 = (v) => Number(v.toFixed(4));
    const angleSommet = (j) => -90 - pas / 2 + j * pas;
    const sommet = (j) => {
      const a = rad(angleSommet(j));
      return [R * Math.cos(a), R * Math.sin(a)];
    };
    const surPuits = (j) => {
      const a = rad(angleSommet(j));
      return [rd * Math.cos(a), rd * Math.sin(a)];
    };
    const RL = R + PLATEAU_ECART / Math.cos(Math.PI / q);
    const octo = (rayon) => {
      let d = '';
      for (let j = 0; j < q; j += 1) {
        const a = rad(angleSommet(j));
        d += (j ? 'L' : 'M') + n4(rayon * Math.cos(a)) + ' ' + n4(rayon * Math.sin(a));
      }
      return d + 'Z';
    };
    const cercle = (r) => 'M' + n4(r) + ' 0A' + n4(r) + ' ' + n4(r) + ' 0 1 1 ' + n4(-r) +
      ' 0A' + n4(r) + ' ' + n4(r) + ' 0 1 1 ' + n4(r) + ' 0Z';

    const traces = [];
    const boites = [];
    for (let k = 0; k < q; k += 1) {
      const a = surPuits(k);
      const s1 = sommet(k);
      const s2 = sommet((k + 1) % q);
      const b = surPuits((k + 1) % q);
      traces.push('M' + n4(a[0]) + ' ' + n4(a[1]) + 'L' + n4(s1[0]) + ' ' + n4(s1[1]) +
        'L' + n4(s2[0]) + ' ' + n4(s2[1]) + 'L' + n4(b[0]) + ' ' + n4(b[1]) +
        'A' + n4(rd) + ' ' + n4(rd) + ' 0 0 0 ' + n4(a[0]) + ' ' + n4(a[1]) + 'Z');

      let x0 = Infinity; let y0 = Infinity; let x1 = -Infinity; let y1 = -Infinity;
      const voir = (p) => {
        if (p[0] < x0) x0 = p[0];
        if (p[0] > x1) x1 = p[0];
        if (p[1] < y0) y0 = p[1];
        if (p[1] > y1) y1 = p[1];
      };
      voir(a); voir(s1); voir(s2); voir(b);
      for (let t = 0; t <= 12; t += 1) {
        const ang = rad(angleSommet(k) + (pas * t) / 12);
        voir([rd * Math.cos(ang), rd * Math.sin(ang)]);
      }
      const cote = Math.max(x1 - x0, y1 - y0);
      boites.push({ x: n4((x0 + x1) / 2 - cote / 2), y: n4((y0 + y1) / 2 - cote / 2), c: n4(cote) });
    }
    traces.push(cercle(rd));
    boites.push({ x: n4(-rd), y: n4(-rd), c: n4(2 * rd) });

    let cloisons = '';
    for (let j = 0; j < q; j += 1) {
      const a = surPuits(j);
      const sj = sommet(j);
      cloisons += 'M' + n4(a[0]) + ' ' + n4(a[1]) + 'L' + n4(sj[0]) + ' ' + n4(sj[1]);
    }
    cloisons += cercle(rd);

    return { n: n, q: q, R: R, rd: rd, traces: traces, boites: boites, cloisons: cloisons, octo: octo, RL: RL };
  };

  let tasNo = 0;

  const SIL_ECHELLE = 1.08;

  const FOND_OPACITE = 1;

  const FOND_FLOU = 2;
  const FOND_PENTE = 1.15;
  const FOND_SEUIL = -0.05;

  const bruitTas = (cx, cy, pas) => ({
    x: cx + Math.sin((cx * 7.1) / pas + (cy * 3.3) / pas) * pas * 0.14,
    y: cy + Math.sin((cx * 3.7) / pas + (cy * 5.9) / pas) * pas * 0.1,
    r: 0.9 + 0.2 * (Math.sin(cx * 12.9 + cy * 78.2) * 0.5 + 0.5),
    a: Math.sin(cx * 1.1 + cy * 0.7) * 180,
  });

  const zoomDe = (sil) => {
    if (!sil) return 1;
    const xs = String(sil).match(/-?\d+(?:\.\d+)?/g);
    if (!xs || !xs.length) return 1;
    const demi = Math.max.apply(null, xs.filter((_, i) => i % 2 === 0).map((v) => Math.abs(+v)));
    return demi > 0 ? Math.min(1.47, 100 / demi) : 1;
  };

  const svgTas = (forme, photo) => {
    tasNo += 1;
    const pre = 'cmta' + tasNo;
    const n = forme.trous.length;
    const zoom = zoomDe(forme.sil).toFixed(3);
    return (
      '<svg class="cm-pmx__tas" viewBox="-100 -100 200 200" width="200" height="200" ' +
      'role="img" aria-label="Contenant vide" focusable="false" ' +
      'data-forme="' + forme.cle + '" data-pre="' + pre + '" data-trous="' + n + '" ' +
      'style="--pmx-zoom:' + zoom + '">' +
      '<defs>' +
        '<clipPath id="' + pre + 's"><path d="' + forme.sil + '"/></clipPath>' +
        '<clipPath id="' + pre + 'z"><path d="' + forme.zone + '"/></clipPath>' +
        '<g data-cm-pmx-tas-motifs></g>' +

        '<filter id="' + pre + 'ff" x="-25%" y="-25%" width="150%" height="150%" '+
          'color-interpolation-filters="sRGB">' +

          '<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>' +

          '<feGaussianBlur stdDeviation="' + FOND_FLOU + '"/>' +
          '<feComponentTransfer><feFuncA type="linear" slope="' + FOND_PENTE + '" intercept="' + FOND_SEUIL + '"/></feComponentTransfer>' +
        '</filter>' +

        '<g id="' + pre + 'emp" data-cm-pmx-tas-empreintes></g>' +
        '<mask id="' + pre + 'fm" maskUnits="userSpaceOnUse" x="-100" y="-100" width="200" height="200">' +
          '<use href="#' + pre + 'emp" filter="url(#' + pre + 'ff)"/>' +
        '</mask>' +
      '</defs>' +

      '<image href="' + photo + '" x="-100" y="-100" width="200" height="200" preserveAspectRatio="xMidYMid meet"/>' +

      '<g clip-path="url(#' + pre + 's)">' +
        '<rect x="-100" y="-100" width="200" height="200" fill="#fff" fill-opacity="' + forme.voile +
          '" clip-path="url(#' + pre + 'z)"/>' +

        '<g clip-path="url(#' + pre + 'z)" mask="url(#' + pre + 'fm)" data-cm-pmx-tas-fond></g>' +
        '<g id="' + pre + 'mo" clip-path="url(#' + pre + 'z)" data-cm-pmx-tas-morceaux></g>' +
      '</g>' +

      '<image href="' + photo + '" x="-100" y="-100" width="200" height="200" opacity="' + forme.filigrane + '" preserveAspectRatio="xMidYMid meet"/>' +

      '<path d="' + forme.sil + '" fill="none" stroke="#241b3d" stroke-width="3.2" ' +
        'stroke-linejoin="round" stroke-linecap="round"/>' +
      '</svg>'
    );
  };

  const svgPlateau = (cases) => {
    const g = geoPlateau(cases);
    plateauNo += 1;
    const pre = 'cmpl' + plateauNo;

    let defs = '<radialGradient id="' + pre + 'f" cx="0.5" cy="0.42" r="0.72">' +
      '<stop offset="0" stop-color="#fffafc"/><stop offset="0.62" stop-color="#fff2f8"/>' +
      '<stop offset="1" stop-color="#ffe3ef"/></radialGradient>';
    for (let k = 0; k < g.traces.length; k += 1) {
      defs += '<clipPath id="' + pre + 'c' + k + '"><path d="' + g.traces[k] + '"/></clipPath>';
    }
    defs += '<clipPath id="' + pre + 'o"><path d="' + g.octo(g.R) + '"/></clipPath>';

    const creux = '<g clip-path="url(#' + pre + 'o)">' +
      '<path d="' + g.octo(g.R) + '" fill="none" stroke="rgba(36,27,61,.14)" stroke-width="11"/></g>';

    return '<svg class="cm-pmx__plateau" viewBox="-100 -100 200 200" width="150" height="150" ' +
      'role="img" aria-label="Plateau vide, ' + g.n + ' compartiments" focusable="false" ' +
      'data-cases="' + g.n + '" data-pre="' + pre + '" ' +
      'style="--pmx-zoom:' + Math.min(1.47, 100 / g.R).toFixed(3) + '">' +
      '<defs>' + defs + '</defs>' +
      '<path d="' + g.octo(g.R) + '" fill="url(#' + pre + 'f)"/>' +
      creux +
      '<g data-cm-pmx-plateau-cases></g>' +
      '<path d="' + g.cloisons + '" fill="none" stroke="#fff" stroke-width="4.5" stroke-linecap="round"/>' +
      '<path d="' + g.octo(g.R) + '" fill="none" stroke="#fff" stroke-width="7" stroke-linejoin="round"/>' +
      '<path d="' + g.octo(g.RL) + '" fill="none" stroke="rgba(36,27,61,.22)" stroke-width="1.2" stroke-linejoin="round"/>' +
      '</svg>';
  };

  class CmPickmix extends HTMLElement {
    connectedCallback() {

      if (this.etat) return;

      this.formats = this.lireIlot('[data-cm-pmx-formats]');
      this.regimes = this.lireIlot('[data-cm-pmx-regimes]');
      this.mixes = this.lireIlot('[data-cm-pmx-mixes]');
      this.couleurs = this.lireIlot('[data-cm-pmx-couleurs]').map((c) => ({
        ...c,
        mots: (c.mots || []).map(motsDe).filter(Boolean),
      }));
      this.bonbons = this.lireIlot('[data-cm-pmx-bonbons]');

      const bloques = this.bonbons.filter((b) => b.bloque).length;
      if (bloques) this.bonbons = this.bonbons.filter((b) => !b.bloque);
      this.anneauFormats = this.lireIlot('[data-cm-pmx-anneau-formats]');

      this.formes = this.lireObjet('[data-cm-pmx-formes]');

      const silParPoignee = this.lireObjet('[data-cm-pmx-silhouettes]');
      this.silhouettes = {};
      let silPosees = 0;
      const silDeclarees = Object.keys(silParPoignee).length;
      if (silDeclarees) {
        this.bonbons.forEach((b) => {
          const h = String(b.url || '').split('/products/')[1];
          if (!h) return;
          const u = silParPoignee[h.split('?')[0].toLowerCase()];
          if (u) { this.silhouettes[b.id] = u; silPosees += 1; }
        });
      }

      if (silDeclarees) {
        this.dataset.silhouettes = 'declarees:' + silDeclarees + ' posees:' + silPosees;
      }

      const ilotPerim = this.querySelector('[data-cm-pmx-perimetres]');
      this.perimetres = {};
      if (ilotPerim) {
        try {
          const lu = JSON.parse(ilotPerim.textContent);
          if (lu && typeof lu === 'object' && !Array.isArray(lu)) this.perimetres = lu;
        } catch (e) {
          this.perimetres = {};
        }
      }
      const ilotAnneau = this.querySelector('[data-cm-pmx-anneau-formats]');
      this.cadenasUrl = (ilotAnneau && ilotAnneau.dataset.cadenas) || '';
      this.enTrainDeTourner = false;

      this.taillesRetenues = new Map();
      this.bonbons.forEach((b) => {
        b.cle = normaliser(b.titre);

        const nom = ' ' + motsDe(b.titre) + ' ';
        b.couleurs = this.couleurs
          .filter((c) => b.regles.includes(c.id) || c.mots.some((m) => nom.includes(' ' + m)))
          .map((c) => c.id);
      });
      this.bonbonParId = new Map(this.bonbons.map((b) => [b.id, b]));

      this.pas = Number(this.dataset.pas) || 100;
      this.varietesMinimum = Number(this.dataset.varietesMin) || 1;

      this.etat = {
        etape: 1,
        formatId: null,
        varianteId: null,
        regime: null,
        famille: null,
        recherche: '',
        couleur: null,

        contenants: [new Map()],

        hasards: [new Map()],

        actif: 0,

        plusLoin: 1,

        ajoute: false,

        vue: 'grille',

        quantite: 1,
      };
      this.dataset.etape = '1';

      Object.defineProperties(this.etat, {
        bonbons: {
          get: () => this.etat.contenants[this.etat.actif],
          set: (mix) => {
            this.etat.contenants[this.etat.actif] = mix;
          },
        },
        hasard: {
          get: () => this.etat.hasards[this.etat.actif],
          set: (tirage) => {
            this.etat.hasards[this.etat.actif] = tirage;
          },
        },
      });

      this.fil = this.querySelector('[data-cm-pmx-fil]');
      this.panneaux = [...this.querySelectorAll('[data-cm-pmx-panneau]')];
      this.grille = this.querySelector('[data-cm-pmx-grille]');
      this.grilleVide = this.querySelector('[data-cm-pmx-grille-vide]');
      this.fiche = this.querySelector('[data-cm-pmx-fiche-dialogue]');
      this.recap = this.querySelector('[data-cm-pmx-recap-dialogue]');

      this.addEventListener('click', (e) => this.auClic(e));
      this.addEventListener('change', (e) => this.auChangement(e));
      this.addEventListener('input', (e) => this.aLaSaisie(e));

      this.remplirPoidsFormats();
      this.construireAnneau();

      this.marquerRegimesVides();
      this.appliquerLienProfond();

      this.classList.remove('cm-pmx--lien');
    }

    lireObjet(selecteur) {
      const ilot = this.querySelector(selecteur);
      if (!ilot) return {};
      try {
        const donnees = JSON.parse(ilot.textContent);
        return donnees && typeof donnees === 'object' && !Array.isArray(donnees) ? donnees : {};
      } catch (erreur) {
        console.warn('[cm-pickmix] configuration illisible : ' + selecteur, erreur);
        return {};
      }
    }

    lireIlot(selecteur) {
      const ilot = this.querySelector(selecteur);
      if (!ilot) return [];

      try {
        const donnees = JSON.parse(ilot.textContent);
        return Array.isArray(donnees) ? donnees : [];
      } catch (erreur) {
        console.warn('[cm-pickmix] configuration illisible : ' + selecteur, erreur);
        return [];
      }
    }

    format(id) {
      return this.formats.find((f) => f.id === id) || null;
    }

    auClic(e) {
      const cible = e.target;

      if (this.fiche && (cible === this.fiche || cible.closest('[data-cm-pmx-fiche-fermer]'))) {
        return this.fiche.close();
      }
      if (this.recap && (cible === this.recap || cible.closest('[data-cm-pmx-recap-fermer]'))) {
        return this.recap.close();
      }
      if (cible.closest('[data-cm-pmx-annuler]')) return this.annuler();
      if (cible.closest('[data-cm-pmx-tout-retirer]')) return this.toutRetirer();
      if (cible.closest('[data-cm-pmx-quantite-plus]')) return this.changerQuantite(1);
      if (cible.closest('[data-cm-pmx-quantite-moins]')) return this.changerQuantite(-1);

      const trouver = (attribut) => cible.closest(`[${attribut}]`);
      let el;

      const dans = cible.closest('[data-cm-pmx-dans]');
      if (dans && cible.closest('[data-cm-pmx-plus], [data-cm-pmx-moins], [data-cm-pmx-vider]')) {
        this.activerContenant(Number(dans.dataset.cmPmxDans));
      }
      if ((el = trouver('data-cm-pmx-activer'))) return this.activerContenant(Number(el.dataset.cmPmxActiver));

      if ((el = trouver('data-cm-pmx-oeil'))) return this.ouvrirFiche(Number(el.dataset.cmPmxOeil));
      if ((el = trouver('data-cm-pmx-plus'))) return this.ajouter(Number(el.dataset.cmPmxPlus));
      if ((el = trouver('data-cm-pmx-moins'))) return this.retirer(Number(el.dataset.cmPmxMoins));
      if ((el = trouver('data-cm-pmx-vider'))) return this.retirer(Number(el.dataset.cmPmxVider), true);
      if ((el = trouver('data-cm-pmx-ajouter'))) return this.ajouter(Number(el.dataset.cmPmxAjouter));
      if ((el = trouver('data-cm-pmx-mix'))) return this.appliquerMix(el.dataset.cmPmxMix);
      if (trouver('data-cm-pmx-hasard')) return this.melangeAleatoire();
      if ((el = trouver('data-cm-pmx-valider'))) return this.valider(el);
      if ((el = trouver('data-cm-pmx-vue'))) return this.choisirVue(el.dataset.cmPmxVue);
      if (trouver('data-cm-pmx-recap')) return this.ouvrirRecap();
      if (trouver('data-cm-pmx-contenant')) return this.allerA(1);
      if (trouver('data-cm-pmx-recommencer')) return this.recommencer();

      if ((el = trouver('data-cm-pmx-tourner'))) return this.tournerFormat(Number(el.dataset.cmPmxTourner));

      if ((el = trouver('data-cm-pmx-format'))) return this.choisirFormat(el.dataset.cmPmxFormat, { avancer: true });
      if ((el = trouver('data-cm-pmx-taille'))) return this.changerTaille(Number(el.dataset.cmPmxTaille));

      if ((el = trouver('data-cm-pmx-regime'))) {
        this.choisirRegime(el.dataset.cmPmxRegime);
        return this.allerA(3);
      }

      if ((el = trouver('data-cm-pmx-aller'))) return this.allerA(Number(el.dataset.cmPmxAller));
      if (trouver('data-cm-pmx-suivant')) return this.allerA(this.etat.etape + 1);
      if (trouver('data-cm-pmx-precedent')) return this.allerA(this.etat.etape - 1);
    }

    auChangement(e) {
      if (e.target.matches('[data-cm-pmx-tri-regime]')) return this.choisirRegime(e.target.value);

      if (e.target.matches('[data-cm-pmx-tri-famille]')) {
        this.etat.famille = e.target.value || null;
        this.filtrer();
      }

      if (e.target.matches('[data-cm-pmx-tri-couleur]')) {
        this.etat.couleur = e.target.value || null;
        this.filtrer();
      }
    }

    aLaSaisie(e) {
      if (!e.target.matches('[data-cm-pmx-recherche]')) return;
      this.etat.recherche = normaliser(e.target.value);
      this.filtrer();
    }

    formatsAnneau() {
      if (this.anneauFormats && this.anneauFormats.length) return this.anneauFormats;
      return this.formats.filter((f) => f.image);
    }

    remplissable(f) {

      if (f && f.verrou) return false;
      const reel = f && this.format(f.id);
      return Boolean(reel && reel.variantes.some((v) => v.disponible));
    }

    capaciteDe(format, variante) {
      if (!format) return 0;
      if (format.mode === 'cases') return format.cases;
      const grammes = grammesDans(variante && variante.titre) || grammesDans(format.titreProduit) || format.contenance;
      return Math.max(1, Math.floor(grammes / this.pas));
    }

    ajusterALaCapacite(capacite) {
      let retires = 0;
      this.etat.contenants.forEach((contenant, i) => {
        let total = 0;
        contenant.forEach((n) => { total += n; });

        while (total > capacite && contenant.size) {
          const cles = [...contenant.keys()];
          const id = cles[cles.length - 1];
          const n = contenant.get(id) || 0;
          const enleve = Math.min(n, total - capacite);

          if (enleve >= n) contenant.delete(id);
          else contenant.set(id, n - enleve);

          if (this.etat.hasards && this.etat.hasards[i]) this.etat.hasards[i].delete(id);
          if (i === this.etat.actif) this.majCarte(id);
          total -= enleve;
          retires += enleve;
        }
      });
      return retires;
    }

    compartiments(format = this.format(this.etat.formatId)) {
      if (!format) return 0;
      const dessin = (this.anneauFormats || []).find((f) => f.id === format.id);
      return dessin && dessin.dessin === 'plateau' ? Number(dessin.cases) || 0 : 0;
    }

    limiterAuxCompartiments(format = this.format(this.etat.formatId)) {
      const max = this.compartiments(format);
      if (!max) return 0;
      let retires = 0;
      this.etat.contenants.forEach((contenant, i) => {
        while (contenant.size > max) {
          const cles = [...contenant.keys()];
          const id = cles[cles.length - 1];
          contenant.delete(id);
          if (this.etat.hasards && this.etat.hasards[i]) this.etat.hasards[i].delete(id);
          if (i === this.etat.actif) this.majCarte(id);
          retires += 1;
        }
      });
      return retires;
    }

    tonContenant(format = this.format(this.etat.formatId)) {
      const singulier = ((format && (format.nomPhrase || format.nom)) || 'contenant').toLowerCase();
      return (format && format.genre === 'f' ? 'ta ' : 'ton ') + singulier;
    }

    phraseCompartiments(n, format = this.format(this.etat.formatId)) {
      return (
        pluriel(n, 'bonbon retiré', 'bonbons retirés') + ' : ' + this.tonContenant(format) +
        ' prend ' + this.compartiments(format) + ' bonbons différents au plus, un par compartiment'
      );
    }

    construireAnneau() {
      const zone = this.querySelector('[data-cm-pmx-anneau]');
      if (!zone) return;
      const liste = this.formatsAnneau();
      zone.textContent = '';

      const assez = liste.filter((f) => this.remplissable(f)).length > 1;
      this.querySelectorAll('[data-cm-pmx-tourner]').forEach((b) => { b.hidden = !assez; });

      liste.forEach((f) => {
        zone.appendChild(f.verrou ? this.carteVerrouillee(f) : this.carteAnneau(f));
      });

      const visuels = this.querySelector('[data-cm-pmx-visuels]');
      if (visuels) visuels.classList.add('a-anneau');
    }

    formeDe(f) {
      if (!this.formes || !f || !f.image) return null;
      const nom = String(f.image).split('?')[0].replace(/\/+$/, '').split('/').pop();
      const emp = nom.replace(/\.[^.]+$/, '');
      const cles = Object.keys(this.formes);
      for (let i = 0; i < cles.length; i += 1) {
        const v = this.formes[cles[i]];
        if (v && v.empreinte && emp.indexOf(v.empreinte) === 0) {
          return Object.assign({ cle: cles[i] }, v);
        }
      }
      return null;
    }

    tasSvg() {
      return this.querySelector('.cm-pmx__anneau-carte[data-pos="0"] svg.cm-pmx__tas');
    }

    copies() {
      return [...this.querySelectorAll('[data-cm-pmx-copie]')];
    }

    autresContenants() {
      const liste = [];
      for (let i = 0; i < this.etat.contenants.length; i += 1) {
        if (i !== this.etat.actif) liste.push(i);
      }
      return liste;
    }

    copiesVisibles() {
      if (!this.mqCopies) {
        this.mqCopies = window.matchMedia('(min-width: 990px)');
        const relire = () => this.majContenant();
        if (this.mqCopies.addEventListener) this.mqCopies.addEventListener('change', relire);
        else if (this.mqCopies.addListener) this.mqCopies.addListener(relire);
      }
      return this.mqCopies.matches;
    }

    dessinCentre() {
      const carte = this.querySelector('.cm-pmx__anneau-carte[data-pos="0"]');
      return carte ? carte.querySelector('svg.cm-pmx__tas, svg.cm-pmx__plateau') : null;
    }

    majCopies() {
      const visuels = this.querySelector('[data-cm-pmx-visuels]');
      if (!visuels) return;

      const modele = this.dessinCentre();
      const format = this.format(this.etat.formatId);
      const autres = this.autresContenants();
      const possible = !!modele && !!format && this.copiesVisibles();

      const cle = possible
        ? this.etat.formatId + '/' + (modele.dataset.forme || 'pl' + modele.dataset.cases)
        : '';

      this.copies().forEach((slot, rang) => {
        if (!possible || autres[rang] === undefined) {
          if (slot.firstElementChild) slot.textContent = '';
          slot.dataset.cle = '';
          slot.hidden = true;
          return;
        }
        if (slot.dataset.cle !== cle || !slot.firstElementChild) {
          const forme = this.formeDe(format);

          slot.innerHTML = modele.classList.contains('cm-pmx__plateau')
            ? svgPlateau(modele.dataset.cases)
            : (forme ? svgTas(forme, format.image) : '');
          slot.dataset.cle = slot.firstElementChild ? cle : '';
        }
        slot.hidden = !slot.firstElementChild;
      });

      visuels.classList.toggle(
        'a-copies',
        possible && this.copies().some((slot) => !slot.hidden)
      );
    }

    dessins() {
      const liste = [];
      const centre = this.dessinCentre();
      if (centre) liste.push({ svg: centre, index: this.etat.actif, centre: true });
      const autres = this.autresContenants();
      this.copies().forEach((slot, rang) => {
        const svg = slot.hidden ? null : slot.firstElementChild;
        if (svg && autres[rang] !== undefined) {
          liste.push({ svg: svg, index: autres[rang], centre: false });
        }
      });
      return liste;
    }

    majContenant() {
      this.majCopies();
      const dessins = this.dessins();
      if (!dessins.length) return undefined;

      const delai = this.delaiCase || 0;
      this.delaiCase = 0;

      dessins.forEach((d) => {

        if (d.svg.classList.contains('cm-pmx__plateau')) {
          this.majPlateau(d.svg, d.index, d.centre ? delai : 0, d.centre);
        } else {
          this.majTas(d.svg, d.index, d.centre ? delai : 0, d.centre);
        }
      });
      return undefined;
    }

    majTas(svg, index = this.etat.actif, delai = 0, anime = true) {
      if (!svg) return;
      const forme = this.formes && this.formes[svg.dataset.forme];
      const zone = svg.querySelector('[data-cm-pmx-tas-morceaux]');
      const defs = svg.querySelector('[data-cm-pmx-tas-motifs]');
      if (!forme || !zone || !defs) return;

      const pre = svg.dataset.pre;
      const n = forme.trous.length;
      const capacite = this.capacite() || 1;

      const utilises = n;

      const k = Math.max(0, Math.min(utilises, Math.round((this.prises(index) / capacite) * utilises)));

      const cases = this.accorderCases(capacite, index);
      const SVGNS = 'http://www.w3.org/2000/svg';
      const pas = forme.pas;

      const plafond = forme.haut - pas * 0.9;
      const fond = svg.querySelector('[data-cm-pmx-tas-fond]');

      const emp = svg.querySelector('[data-cm-pmx-tas-empreintes]');

      const empreinteCle = index + '/' + k + '/' + capacite;
      const refaireEmp = !emp || emp.dataset.cle !== empreinteCle;
      if (emp && refaireEmp) { emp.textContent = ''; emp.dataset.cle = empreinteCle; }
      const sommets = [];
      const motifsPortion = [];
      let premiereChute = null;
      let poses = 0;
      let nouveaux = 0;

      for (let i = 0; i < utilises; i += 1) {

        const trou = Math.min(n - 1, Math.round((i * n) / utilises));
        const p = i < k ? Math.min(capacite - 1, Math.floor((i * capacite) / utilises)) : -1;
        const id = p < 0 ? null : cases[p];
        const t = forme.trous[trou];
        const b = bruitTas(t[0], t[1], pas);
        const r = pas * b.r;
        const pose = zone.querySelector('[data-trou="' + i + '"]');
        const posee = pose && pose.dataset.bonbon;

        if (!id) {
          if (id) poses += 1;
          if (pose && !pose.dataset.sortie) {
            pose.dataset.sortie = '1';
            const fin = () => { if (pose.parentNode) pose.parentNode.removeChild(pose); };
            if (anime && pose.animate && !this.mouvementReduit()) {
              const a = pose.animate(
                [{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.3)', opacity: 0 }],
                { duration: 180, easing: 'ease-in', fill: 'forwards' }
              );
              a.finished.then(fin, fin);
              window.setTimeout(fin, 600);
            } else fin();
          }
          continue;
        }

        poses += 1;

        if (sommets[p] === undefined) motifsPortion[p] = pre + 'm' + i;
        if (sommets[p] === undefined || b.y < sommets[p]) sommets[p] = b.y;

        if (posee === String(id) && !pose.dataset.sortie) {
          if (emp && refaireEmp) {
            const e3 = document.createElementNS(SVGNS, 'ellipse');
            e3.setAttribute('cx', b.x.toFixed(2));
            e3.setAttribute('cy', b.y.toFixed(2));
            e3.setAttribute('rx', (r * 0.657).toFixed(2));
            e3.setAttribute('ry', (r * 0.546).toFixed(2));
            e3.setAttribute('fill', '#fff');
            e3.style.transform = 'rotate(' + b.a.toFixed(1) + 'deg)';
            e3.style.transformBox = 'fill-box';
            e3.style.transformOrigin = 'center center';
            emp.appendChild(e3);
          }
          continue;
        }
        if (pose && pose.parentNode) pose.parentNode.removeChild(pose);

        const motif = pre + 'm' + i;
        if (!defs.querySelector('#' + motif)) {
          const p = document.createElementNS(SVGNS, 'pattern');
          p.setAttribute('id', motif);
          p.setAttribute('patternUnits', 'userSpaceOnUse');
          p.setAttribute('width', '64');
          p.setAttribute('height', '64');

          p.setAttribute('patternTransform', 'rotate(' + ((i * 37) % 90) + ')');
          const im = document.createElementNS(SVGNS, 'image');
          im.setAttribute('width', '64');
          im.setAttribute('height', '64');
          im.setAttribute('preserveAspectRatio', 'xMidYMid slice');
          p.appendChild(im);
          defs.appendChild(p);
        }
        defs.querySelector('#' + motif).querySelector('image')
          .setAttribute('href', this.photoDe(id));

        const tour = b.a.toFixed(1) + 'deg';

        const sil = this.silhouettes && this.silhouettes[id];
        const el = document.createElementNS(SVGNS, sil ? 'image' : 'ellipse');
        if (sil) {

          const cote = r * 0.657 * 2 * SIL_ECHELLE;
          el.setAttribute('href', sil);
          el.setAttribute('x', (b.x - cote / 2).toFixed(2));
          el.setAttribute('y', (b.y - cote / 2).toFixed(2));
          el.setAttribute('width', cote.toFixed(2));
          el.setAttribute('height', cote.toFixed(2));
          el.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        } else {
        el.setAttribute('cx', b.x.toFixed(2));
        el.setAttribute('cy', b.y.toFixed(2));

        el.setAttribute('rx', (r * 0.657).toFixed(2));
        el.setAttribute('ry', (r * 0.546).toFixed(2));
        }

        el.style.transform = 'rotate(' + tour + ')';
        if (!sil) {
        el.setAttribute('fill', 'url(#' + motif + ')');

        el.setAttribute('stroke', 'rgba(36,27,61,.32)');
        el.setAttribute('stroke-width', '1.1');
        el.setAttribute('vector-effect', 'non-scaling-stroke');
        }
        el.dataset.trou = String(i);
        el.dataset.bonbon = String(id);

        el.style.transformBox = 'fill-box';
        el.style.transformOrigin = 'center center';
        zone.appendChild(el);

          if (emp && refaireEmp) {
            const e2 = document.createElementNS(SVGNS, 'ellipse');
            e2.setAttribute('cx', b.x.toFixed(2));
            e2.setAttribute('cy', b.y.toFixed(2));
            e2.setAttribute('rx', (r * 0.657).toFixed(2));
            e2.setAttribute('ry', (r * 0.546).toFixed(2));
            e2.setAttribute('fill', '#fff');
            e2.style.transform = 'rotate(' + b.a.toFixed(1) + 'deg)';
            e2.style.transformBox = 'fill-box';
            e2.style.transformOrigin = 'center center';
            emp.appendChild(e2);
          }
        nouveaux += 1;

        if (anime && el.animate && !this.mouvementReduit()) {

          const chute = Math.max(26, Math.min(110, b.y - plafond));

          if (premiereChute === null) premiereChute = 210 + Math.round(chute * 2);

          el.animate(
            [
              { transform: 'translateY(' + (-chute).toFixed(1) + 'px) scale(.94) rotate(' + tour + ')', opacity: 0, offset: 0, easing: 'linear' },

              { transform: 'translateY(' + (-chute * 0.88).toFixed(1) + 'px) scale(.96) rotate(' + tour + ')', opacity: 1, offset: 0.1, easing: 'cubic-bezier(.42,0,.86,.4)' },
              { transform: 'translateY(0px) scale(1) rotate(' + tour + ')', opacity: 1, offset: 0.74, easing: 'cubic-bezier(.3,0,.25,1)' },

              { transform: 'translateY(1.6px) scale(1.11, .83) rotate(' + tour + ')', opacity: 1, offset: 0.86, easing: 'cubic-bezier(.3,0,.25,1)' },
              { transform: 'translateY(0px) scale(1) rotate(' + tour + ')', opacity: 1, offset: 1 },
            ],
            {

              duration: 210 + Math.round(chute * 2),

              delay: delai + Math.min(30, 460 / Math.max(1, k)) * nouveaux,
              fill: 'backwards',
            }
          );
        }
      }

      if (fond) {
        const vues = {};
        Array.prototype.forEach.call(fond.children, (e) => {
          if (e.dataset.bande) vues[e.dataset.bande] = e;
        });

        let bas = forme.bas + 6;
        for (let p = 0; p < capacite; p += 1) {
          const dejaLa = vues[p];
          delete vues[p];
          if (sommets[p] === undefined) {
            if (dejaLa) fond.removeChild(dejaLa);
            continue;
          }
          const haut = sommets[p];
          const bande = dejaLa || document.createElementNS(SVGNS, 'rect');
          bande.setAttribute('x', '-100');
          bande.setAttribute('width', '200');
          bande.setAttribute('y', haut.toFixed(2));
          bande.setAttribute('height', Math.max(0, bas - haut).toFixed(2));
          bande.setAttribute('fill', 'url(#' + motifsPortion[p] + ')');
          bande.setAttribute('opacity', String(FOND_OPACITE));
          bande.dataset.bande = String(p);
          if (!dejaLa) {
            fond.appendChild(bande);

            if (anime && bande.animate && !this.mouvementReduit()) {
              bande.animate(
                [{ opacity: 0 }, { opacity: String(FOND_OPACITE) }],

                { duration: 300, delay: delai + (premiereChute === null ? 90 : premiereChute - 40),
                  fill: 'backwards', easing: 'ease-out' }
              );
            }
          }

          bas = haut + 0.6;
        }
        for (const reste in vues) if (vues[reste]) fond.removeChild(vues[reste]);
      }

      const pct = Math.round((this.prises(index) / capacite) * 100);
      const quoi = this.etat.contenants.length > 1 ? this.nomContenant(index) : 'Contenant';
      svg.setAttribute('aria-label', poses ? quoi + ' rempli a ' + pct + ' %' : quoi + ' vide');
    }

    photoDe(id) {
      const c = this.cartes && this.cartes.get(id);
      const img = c && c.carte && c.carte.querySelector('img');
      return img ? (img.currentSrc || img.src) : '';
    }

    casesParBonbon(mix, n) {
      const capacite = this.capacite();
      let prises = 0;
      mix.forEach((k) => { prises += k; });
      if (!prises || !capacite || capacite === n) return mix;

      let pleines = Math.round((prises * n) / capacite);
      if (prises < capacite) pleines = Math.min(pleines, n - 1);
      pleines = Math.min(n, Math.max(mix.size, pleines));

      const voulues = new Map();
      mix.forEach((k, id) => voulues.set(id, 1));
      const reste = pleines - mix.size;
      const enPlus = prises - mix.size;
      if (reste <= 0 || enPlus <= 0) return voulues;

      const restes = [];
      let donnees = 0;
      mix.forEach((k, id) => {
        const part = ((k - 1) * reste) / enPlus;
        const entier = Math.floor(part);
        voulues.set(id, 1 + entier);
        donnees += entier;
        restes.push([part - entier, id]);
      });

      restes.sort((x, y) => y[0] - x[0]);
      for (let j = 0; j < restes.length && donnees < reste; j += 1, donnees += 1) {
        voulues.set(restes[j][1], voulues.get(restes[j][1]) + 1);
      }
      return voulues;
    }

    accorderCases(n, index = this.etat.actif) {
      if (!Array.isArray(this.etat.casesPar)) this.etat.casesPar = [];
      if (!Array.isArray(this.etat.casesPar[index]) || this.etat.casesPar[index].length !== n) {
        this.etat.casesPar[index] = new Array(n).fill(null);
      }
      const cases = this.etat.casesPar[index];
      const mix = this.casesParBonbon(this.etat.contenants[index] || new Map(), n);
      const actuel = new Map();
      cases.forEach((id) => { if (id) actuel.set(id, (actuel.get(id) || 0) + 1); });

      actuel.forEach((combien, id) => {
        let trop = combien - (mix.get(id) || 0);
        for (let k = cases.length - 1; k >= 0 && trop > 0; k -= 1) {
          if (cases[k] === id) { cases[k] = null; trop -= 1; }
        }
      });

      mix.forEach((combien, id) => {
        let manque = combien - (actuel.get(id) || 0);
        for (let k = 0; k < cases.length && manque > 0; k += 1) {
          if (!cases[k]) { cases[k] = id; manque -= 1; }
        }
      });
      return cases;
    }

    majPlateau(svg, index = this.etat.actif, delai = 0, anime = true) {
      if (!svg) return;
      const zone = svg.querySelector('[data-cm-pmx-plateau-cases]');
      if (!zone) return;
      const g = geoPlateau(svg.dataset.cases);
      const pre = svg.dataset.pre;
      const cases = this.accorderCases(g.n, index);
      const SVGNS = 'http://www.w3.org/2000/svg';
      let pleines = 0;

      for (let k = 0; k < g.n; k += 1) {
        const id = cases[k];
        if (id) pleines += 1;
        const pose = zone.querySelector('[data-case="' + k + '"]');
        const posee = pose && pose.dataset.bonbon;

        if (!id) {
          if (pose && !pose.dataset.sortie) {

            pose.dataset.sortie = '1';
            const img = pose.querySelector('image');
            const fin = () => { if (pose.parentNode) pose.parentNode.removeChild(pose); };
            if (anime && img && img.animate && !this.mouvementReduit()) {
              const a = img.animate(
                [{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.3)', opacity: 0 }],
                { duration: 180, easing: 'ease-in', fill: 'forwards' }
              );
              a.finished.then(fin, fin);
              window.setTimeout(fin, 600);
            } else fin();
          }
          continue;
        }

        if (posee === String(id) && !pose.dataset.sortie) continue;
        if (pose && pose.parentNode) pose.parentNode.removeChild(pose);

        const grp = document.createElementNS(SVGNS, 'g');
        grp.setAttribute('clip-path', 'url(#' + pre + 'c' + k + ')');
        grp.dataset.case = String(k);
        grp.dataset.bonbon = id;

        const b = g.boites[k];
        const img = document.createElementNS(SVGNS, 'image');
        img.setAttribute('href', this.photoDe(id));
        img.setAttribute('x', b.x);
        img.setAttribute('y', b.y);
        img.setAttribute('width', b.c);
        img.setAttribute('height', b.c);
        img.setAttribute('preserveAspectRatio', 'xMidYMid slice');

        img.style.transformBox = 'fill-box';
        img.style.transformOrigin = 'center center';
        grp.appendChild(img);

        const ombre = document.createElementNS(SVGNS, 'path');
        ombre.setAttribute('d', g.traces[k]);
        ombre.setAttribute('fill', 'none');
        ombre.setAttribute('stroke', 'rgba(36,27,61,.22)');
        ombre.setAttribute('stroke-width', '6');
        grp.appendChild(ombre);
        zone.appendChild(grp);

        if (anime && img.animate && !this.mouvementReduit()) {
          img.animate(
            [
              { transform: 'scale(.2)', opacity: 0 },
              { transform: 'scale(1.08)', opacity: 1, offset: 0.7 },
              { transform: 'scale(1)', opacity: 1 },
            ],
            { duration: 380, delay: delai, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' }
          );
        }
      }

      const surplus = Math.max(0, this.prises(index) - g.n);
      const quoi = this.etat.contenants.length > 1 ? this.nomContenant(index) : 'Plateau';
      svg.setAttribute(
        'aria-label',
        pleines
          ? quoi + ' : ' + pleines + ' sur ' + g.n + ' compartiments remplis' +
            (surplus ? ', plus ' + surplus + ' portion' + (surplus > 1 ? 's' : '') + ' hors compartiment' : '')
          : quoi + ' vide, ' + g.n + ' compartiments'
      );
      svg.classList.toggle('a-surplus', surplus > 0);
    }

    carteAnneau(f) {

      if (f.dessin === 'tas') {
        const forme = this.formeDe(f);
        if (forme) {
          const carte = document.createElement('span');
          carte.className = 'cm-pmx__anneau-carte est-dessin';
          carte.dataset.cmPmxAnneauFormat = f.id;
          carte.innerHTML = svgTas(forme, f.image);
          if (!this.remplissable(f)) carte.classList.add('est-a-venir');
          return carte;
        }

      }

      if (f.dessin === 'plateau') {
        const carte = document.createElement('span');
        carte.className = 'cm-pmx__anneau-carte est-dessin';
        carte.dataset.cmPmxAnneauFormat = f.id;
        carte.innerHTML = svgPlateau(f.cases);
        if (!this.remplissable(f)) carte.classList.add('est-a-venir');
        return carte;
      }
      const img = document.createElement('img');
      img.className = 'cm-pmx__anneau-carte';
      img.src = f.image;
      img.alt = '';
      img.width = 150;
      img.height = 150;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.dataset.cmPmxAnneauFormat = f.id;
      if (!this.remplissable(f)) img.classList.add('est-a-venir');
      return img;
    }

    carteVerrouillee(f) {
      const carte = document.createElement('span');
      carte.className = 'cm-pmx__anneau-carte est-verrou';
      carte.dataset.cmPmxAnneauFormat = f.id;
      carte.setAttribute('aria-hidden', 'true');

      const flou = document.createElement('span');
      flou.className = 'cm-pmx__anneau-flou';

      const img = document.createElement('img');
      img.src = f.image;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      flou.appendChild(img);
      carte.appendChild(flou);

      if (this.cadenasUrl) {
        const cadenas = document.createElement('img');
        cadenas.className = 'cm-pmx__anneau-cadenas';
        cadenas.src = this.cadenasUrl;
        cadenas.alt = '';
        cadenas.loading = 'lazy';
        cadenas.decoding = 'async';
        carte.appendChild(cadenas);
      }

      return carte;
    }

    majAnneau() {
      const zone = this.querySelector('[data-cm-pmx-anneau]');
      if (!zone || !zone.children.length) return;

      const liste = this.formatsAnneau();
      const total = liste.length;
      const courant = liste.findIndex((f) => f.id === this.etat.formatId);

      if (courant < 0) {
        Array.from(zone.children).forEach((carte) => carte.removeAttribute('data-pos'));
        this.querySelectorAll('[data-cm-pmx-tourner]').forEach((b) => { b.hidden = true; });
        return;
      }
      this.querySelectorAll('[data-cm-pmx-tourner]').forEach((b) => {
        b.hidden = liste.filter((f) => this.remplissable(f)).length < 2;
      });

      Array.from(zone.children).forEach((carte) => {
        const i = liste.findIndex((f) => f.id === carte.dataset.cmPmxAnneauFormat);
        let ecart = i - courant;
        if (ecart > total / 2) ecart -= total;
        if (ecart < -total / 2) ecart += total;

        if (Math.abs(ecart) > 2) carte.removeAttribute('data-pos');
        else carte.dataset.pos = String(ecart);
      });

      const suivant = this.prochainFormat(1);
      const precedent = this.prochainFormat(-1);
      const decrire = (f) => (f ? 'Passer à ' + f.nom : '');
      const gauche = this.querySelector('[data-cm-pmx-tourner="-1"]');
      const droite = this.querySelector('[data-cm-pmx-tourner="1"]');
      if (gauche) gauche.setAttribute('aria-label', decrire(precedent) || 'Format précédent');
      if (droite) droite.setAttribute('aria-label', decrire(suivant) || 'Format suivant');
    }

    prochainFormat(pas) {
      const liste = this.formatsAnneau();
      const total = liste.length;
      if (!total) return null;

      let depart = liste.findIndex((f) => f.id === this.etat.formatId);
      if (depart < 0) depart = 0;

      for (let k = 1; k <= total; k++) {
        const i = (((depart + pas * k) % total) + total) % total;
        const f = liste[i];
        if (f.id !== this.etat.formatId && this.remplissable(f)) return this.format(f.id);
      }
      return null;
    }

    tournerFormat(pas) {
      if (this.enTrainDeTourner) return;

      const cible = this.prochainFormat(pas);
      if (!cible) return;

      const retenue = this.taillesRetenues && this.taillesRetenues.get(cible.id);
      const dispo = cible.variantes.filter((v) => v.disponible);
      if (!dispo.length) return;
      const parCapacite = dispo
        .slice()
        .sort((a, b) => this.capaciteDe(cible, a) - this.capaciteDe(cible, b));

      const prises = this.etat.contenants.reduce(
        (m, _, i) => Math.max(m, this.prises(i)),
        0,
      );
      const variante =
        dispo.find((v) => v.id === retenue) ||
        parCapacite.find((v) => this.capaciteDe(cible, v) >= prises) ||
        parCapacite[parCapacite.length - 1];
      if (!variante) return;

      const retires = this.ajusterALaCapacite(this.capaciteDe(cible, variante));
      const enTrop = this.limiterAuxCompartiments(cible);

      this.enTrainDeTourner = true;
      this.etat.varianteId = variante.id;
      this.choisirFormat(cible.id);

      this.choisirTaille(variante.id);

      this.majPropositions();
      this.filtrer();
      this.majResume();
      this.majContenant();

      const horsSelection = this.retirerIncompatibles({ muet: true });

      const bouts = [];
      if (retires) {
        bouts.push(
          pluriel(retires, 'bonbon retiré', 'bonbons retirés') + ' : ' + cible.nom + ' est plus petit'
        );
      }
      if (horsSelection) {
        bouts.push(
          pluriel(horsSelection, 'bonbon retiré', 'bonbons retirés') +
            ' : absent' + (horsSelection > 1 ? 's' : '') + ' de la sélection de ' + cible.nom
        );
      }
      if (enTrop) bouts.push(this.phraseCompartiments(enTrop, cible));
      this.statut(bouts.length ? bouts.join('. ') + '.' : '');

      setTimeout(() => {
        this.enTrainDeTourner = false;
      }, 540);
    }

    choisirFormat(id, { avancer = false } = {}) {
      const format = this.format(id);
      if (!format) return;

      this.etat.formatId = id;
      this.etat.varianteId = null;
      this.annonce('');

      this.querySelectorAll('[data-cm-pmx-format]').forEach((btn) => {
        const actif = btn.dataset.cmPmxFormat === id;
        btn.classList.toggle('is-active', actif);
        btn.setAttribute('aria-pressed', String(actif));
      });

      this.masquerTailles();

      if (format.variantes.length === 1 && format.variantes[0].disponible) {
        this.etat.varianteId = format.variantes[0].id;
      } else {
        this.dessinerTailles(format);
        const zone = this.zoneTaillesDe(id);
        if (zone) zone.hidden = false;
      }

      this.majBoutonSuivant();
      this.majFil();
      this.dessinerPoids();

      this.marquerRegimesVides();

      if (avancer && this.etat.varianteId) this.allerA(2);
    }

    remplirPoidsFormats() {
      this.formats.forEach((f) => {
        const zone = this.querySelector(`[data-cm-pmx-format-poids="${CSS.escape(f.id)}"]`);
        if (!zone) return;

        if (f.mode === 'cases') {
          zone.textContent = pluriel(f.cases, 'case', 'cases');
        } else if (f.variantes.length === 1) {
          const grammes = grammesDans(f.variantes[0].titre) || grammesDans(f.titreProduit) || f.contenance;
          zone.textContent = grammes.toLocaleString('fr-FR') + ' g';
        }
      });

      this.querySelectorAll('[data-cm-pmx-format-poids][data-grammes]').forEach((zone) => {
        zone.textContent = Number(zone.dataset.grammes).toLocaleString('fr-FR') + ' g';
      });
    }

    zoneTaillesDe(id) {
      return this.querySelector(`[data-cm-pmx-tailles="${CSS.escape(id)}"]`);
    }

    masquerTailles() {
      this.querySelectorAll('[data-cm-pmx-tailles]').forEach((zone) => {
        zone.hidden = true;
      });
    }

    dessinerTailles(format) {
      const liste = this.querySelector(
        `[data-cm-pmx-tailles-liste="${CSS.escape(format.id)}"]`
      );
      if (!liste) return;

      liste.textContent = '';

      format.variantes.forEach((v) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');

        btn.type = 'button';
        btn.className = 'cm-pmx__taille';
        btn.dataset.cmPmxTaille = v.id;
        btn.setAttribute('aria-pressed', 'false');
        btn.disabled = !v.disponible;

        const nom = document.createElement('span');
        nom.className = 'cm-pmx__taille-nom';
        nom.textContent = v.titre;

        const prix = document.createElement('span');
        prix.className = 'cm-pmx__taille-prix';
        prix.textContent = v.prixFormate;

        btn.append(nom, prix);

        if (!v.disponible) {
          const rupture = document.createElement('span');
          rupture.className = 'cm-pmx__taille-rupture';
          rupture.textContent = 'Épuisé';
          btn.appendChild(rupture);
        }

        li.appendChild(btn);
        liste.appendChild(li);
      });
    }

    choisirTaille(id, { avancer = false } = {}) {
      this.etat.varianteId = id;
      if (this.taillesRetenues && this.etat.formatId) this.taillesRetenues.set(this.etat.formatId, id);

      this.querySelectorAll('[data-cm-pmx-taille]').forEach((btn) => {
        const actif = Number(btn.dataset.cmPmxTaille) === id;
        btn.classList.toggle('is-active', actif);
        btn.setAttribute('aria-pressed', String(actif));
      });

      this.majBoutonSuivant();
      this.majFil();
      if (avancer) this.allerA(2);
    }

    changerTaille(id) {
      const format = this.format(this.etat.formatId);
      const variante = format && format.variantes.find((v) => v.id === id);
      if (!variante || !variante.disponible) return;

      const depuisEtape1 = this.etat.etape === 1;
      this.choisirTaille(id, { avancer: depuisEtape1 });

      const retires = this.ajusterALaCapacite(this.capacite());

      this.annulation = null;

      this.majResume();

      this.majContenant();
      this.dessinerPoids();

      if (this.etat.etape >= 3) {
        this.statut(
          retires
            ? pluriel(retires, 'bonbon retiré', 'bonbons retirés') + ' : ' + variante.titre + ' est plus petit.'
            : ''
        );
      }
    }

    dessinerPoids() {
      const zone = this.querySelector('[data-cm-pmx-poids-zone]');
      const liste = this.querySelector('[data-cm-pmx-poids]');
      if (!zone || !liste) return;

      const format = this.format(this.etat.formatId);
      const variantes = (format && format.variantes) || [];

      if (variantes.length < 2) {
        zone.hidden = true;
        liste.textContent = '';
        return;
      }

      liste.textContent = '';
      variantes.forEach((v) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cm-pmx__poids-pilule';
        btn.dataset.cmPmxTaille = v.id;
        btn.disabled = !v.disponible;
        btn.textContent = v.titre;

        const actif = v.id === this.etat.varianteId;
        btn.classList.toggle('is-active', actif);
        btn.setAttribute('aria-pressed', String(actif));
        btn.setAttribute(
          'aria-label',
          v.disponible ? v.titre + ' — ' + v.prixFormate : v.titre + ' — épuisé'
        );
        if (!v.disponible) btn.title = 'Épuisé';

        liste.appendChild(btn);
      });

      zone.hidden = false;
    }

    majBoutonSuivant() {
      const btn = this.querySelector('[data-cm-pmx-panneau="1"] [data-cm-pmx-suivant]');
      if (btn) btn.disabled = !this.etat.varianteId;
    }

    choisirRegime(id) {
      this.etat.regime = id || null;

      this.querySelectorAll('[data-cm-pmx-regime]').forEach((btn) => {
        const actif = btn.dataset.cmPmxRegime === (id || '');
        btn.classList.toggle('is-active', actif);
        btn.setAttribute('aria-pressed', String(actif));
      });

      const liste = this.querySelector('[data-cm-pmx-tri-regime]');
      if (liste) liste.value = id || '';

      this.retirerIncompatibles();
      this.majPropositions();

      if (this.cartes) {
        this.filtrer();
        this.majResume();
        this.majContenant();
      }
    }

    marquerRegimesVides() {
      if (!this.bonbons.length) return;

      this.regimes.forEach((r) => {

        const partout = this.bonbons.some((b) => b.regles.includes(r.id));
        const ici = this.bonbons.some((b) => b.regles.includes(r.id) && this.dansLePerimetre(b));
        const vide = !ici;
        const mot = partout ? 'Pas pour ce format' : 'Bientôt';

        const bouton = this.querySelector(`[data-cm-pmx-regime="${CSS.escape(r.id)}"]`);
        if (bouton) {
          bouton.disabled = vide;
          bouton.classList.toggle('is-vide', vide);

          let note = bouton.querySelector('.cm-pmx__regime-bientot');
          if (vide) {
            if (!note) {
              note = element('span', 'cm-pmx__regime-bientot');
              bouton.appendChild(note);
            }
            note.textContent = mot;
          } else if (note) {
            note.remove();
          }
        }

        const option = this.querySelector(`[data-cm-pmx-tri-regime] option[value="${CSS.escape(r.id)}"]`);
        if (option) {
          if (option.dataset.libelle === undefined) option.dataset.libelle = option.textContent;
          option.disabled = vide;
          option.textContent = vide ? option.dataset.libelle + ' (' + mot.toLowerCase() + ')' : option.dataset.libelle;
        }
      });
    }

    appliquerLienProfond() {
      const params = new URLSearchParams(window.location.search);
      const demande = params.get('contenant');
      if (!demande) return;

      const tailleDemandee = params.get('taille');

      const cible = this.formats.find((f) => normaliser(f.nom) === normaliser(demande));
      if (!cible) return;

      this.choisirFormat(cible.id);

      if (tailleDemandee) {
        const variante = cible.variantes.find(
          (v) => normaliser(v.titre) === normaliser(tailleDemandee)
        );

        if (variante && variante.disponible) this.choisirTaille(variante.id);
      }

      if (this.etat.varianteId) this.allerA(2, { defiler: false });
    }

    allerA(numero, { defiler = true } = {}) {
      const total = this.panneaux.length;
      if (numero < 1 || numero > total) return;

      if (!this.accessible(numero)) return;

      this.etat.etape = numero;
      this.etat.plusLoin = Math.max(this.etat.plusLoin, numero);

      this.dataset.etape = String(numero);

      if (numero >= 3) this.dataset.entame = '';

      this.panneaux.forEach((p) => {
        const actif = Number(p.dataset.cmPmxPanneau) === numero;
        p.hidden = !actif;
        p.classList.toggle('is-active', actif);
      });

      this.majFil();

      if (numero === 3) this.entrerCatalogue();
      if (!defiler) return;

      const panneau = this.panneaux.find((p) => Number(p.dataset.cmPmxPanneau) === numero);
      const haut = panneau.getBoundingClientRect().top;

      if (haut < 0 || haut > window.innerHeight * 0.6) {
        const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panneau.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
      }
    }

    accessible(numero) {
      if (this.etat.ajoute) return numero === 4;
      if (numero === 1) return true;
      if (!this.etat.varianteId || numero === 4) return false;
      return numero <= Math.max(this.etat.plusLoin, this.etat.etape + 1);
    }

    majFil() {
      this.fil.querySelectorAll('[data-etape]').forEach((item) => {
        const n = Number(item.dataset.etape);
        const actuelle = n === this.etat.etape;
        item.classList.toggle('is-active', actuelle);
        item.classList.toggle('is-faite', n < this.etat.etape);

        const bouton = item.querySelector('[data-cm-pmx-aller]');
        if (!bouton) return;
        bouton.disabled = actuelle || !this.accessible(n);
        if (actuelle) bouton.setAttribute('aria-current', 'step');
        else bouton.removeAttribute('aria-current');
      });
    }

    entrerCatalogue() {
      this.construireGrille();
      this.dessinerPoids();

      const liste = this.querySelector('[data-cm-pmx-tri-regime]');
      if (liste) liste.value = this.etat.regime || '';

      const horsRegime = this.retirerIncompatibles();

      const enTrop = this.limiterAuxCompartiments();
      this.majPropositions();
      this.filtrer();
      this.majResume();
      this.majContenant();
      if (enTrop && !horsRegime) this.statut(this.phraseCompartiments(enTrop) + '.');
    }

    construireGrille() {
      if (this.cartes) return;

      this.cartes = new Map();
      const fragment = document.createDocumentFragment();

      this.bonbons.forEach((b) => {
        const carte = element('li', 'cm-pmx__bonbon');

        const ajout = element('button', 'cm-pmx__bonbon-ajout');
        ajout.type = 'button';
        ajout.dataset.cmPmxAjouter = b.id;

        const regimes = this.regimes.filter((r) => b.regles.includes(r.id));
        ajout.setAttribute(
          'aria-label',
          'Ajouter ' + b.titre +
            (regimes.length ? ' — ' + regimes.map((r) => r.nom).join(', ') : '') +
            (b.sup ? ' — supplément ' + b.sup.l + ' la portion' : '')
        );

        const media = element('span', 'cm-pmx__bonbon-media');
        if (b.image) {
          const img = element('img', 'cm-pmx__bonbon-img');
          img.src = b.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 360;
          img.height = 360;
          media.appendChild(img);
        } else {
          media.appendChild(element('span', 'cm-pmx__bonbon-sans-image', '🍬'));
        }
        if (regimes.length) {
          const badges = element('span', 'cm-pmx__badges');
          regimes.forEach((r) => {
            const badge = element('span', 'cm-pmx__badge');
            if (r.image) {
              const icone = element('img', 'cm-pmx__badge-icone');
              icone.src = r.image;
              icone.alt = '';
              icone.width = 16;
              icone.height = 16;
              icone.loading = 'lazy';
              badge.appendChild(icone);
            }
            badge.appendChild(document.createTextNode(r.nom));
            badges.appendChild(badge);
          });
          media.appendChild(badges);
        }

        if (b.sup) {
          media.appendChild(element('span', 'cm-pmx__bonbon-sup', '+ ' + b.sup.l));
        }

        ajout.append(media, element('span', 'cm-pmx__bonbon-nom', b.titre));

        const oeil = element('button', 'cm-pmx__bonbon-oeil');
        oeil.type = 'button';
        oeil.dataset.cmPmxOeil = b.id;
        oeil.setAttribute('aria-label', 'Ingrédients et allergènes : ' + b.titre);
        oeil.innerHTML = ICONE_OEIL;

        const retrait = element('button', 'cm-pmx__bonbon-retrait', '×');
        retrait.type = 'button';
        retrait.dataset.cmPmxVider = b.id;
        retrait.setAttribute('aria-label', 'Retirer ' + b.titre);
        retrait.hidden = true;

        const pied = element('div', 'cm-pmx__bonbon-pied');
        const invite = element('span', 'cm-pmx__bonbon-invite', '+ Ajouter');
        invite.setAttribute('aria-hidden', 'true');

        const dosage = element('div', 'cm-pmx__dosage');
        dosage.hidden = true;

        const moins = element('button', '', '−');
        moins.type = 'button';
        moins.dataset.cmPmxMoins = b.id;
        moins.setAttribute('aria-label', 'Une portion de moins : ' + b.titre);

        const valeur = element('span', 'cm-pmx__dosage-valeur');

        const plus = element('button', '', '+');
        plus.type = 'button';
        plus.dataset.cmPmxPlus = b.id;
        plus.setAttribute('aria-label', 'Une portion de plus : ' + b.titre);

        dosage.append(moins, valeur, plus);
        pied.append(invite, dosage);
        carte.append(ajout, oeil, retrait, pied);

        this.cartes.set(b.id, { carte, retrait, invite, dosage, valeur });
        fragment.appendChild(carte);
      });

      this.grille.appendChild(fragment);
    }

    dansLePerimetre(b, formatId) {
      const id = formatId || this.etat.formatId;
      if (!id) return true;
      const poignee = this.perimetres && this.perimetres[id];
      if (!poignee) return true;
      return !!(b && b.perimetres && b.perimetres.includes(poignee));
    }

    compatible(b) {
      return (
        (!this.etat.regime || b.regles.includes(this.etat.regime)) &&
        this.dansLePerimetre(b)
      );
    }

    phraseRetrait(nRegime, nFormat) {
      const n = nRegime + nFormat;
      const pluri = n > 1 ? 's' : '';
      let raison;
      if (nRegime && nFormat) {
        raison = 'hors du regime ou de la selection de ce format';
      } else if (nRegime) {
        raison = 'pas compatible' + pluri + ' avec ce regime';
      } else {
        raison = 'absent' + pluri + ' de la selection de ce format';
      }
      return pluriel(n, 'bonbon retire', 'bonbons retires') + ' : ' + raison + '.';
    }

    filtrer() {
      if (!this.cartes) return;

      const { recherche, famille, couleur } = this.etat;
      let visibles = 0;

      this.bonbons.forEach((b) => {
        const montre =
          this.compatible(b) &&
          (!famille || b.familles.includes(famille)) &&
          (!couleur || b.couleurs.includes(couleur)) &&
          (!recherche || b.cle.includes(recherche));

        this.cartes.get(b.id).carte.hidden = !montre;
        if (montre) visibles++;
      });

      this.grilleVide.hidden = visibles > 0;
      if (visibles) return;

      if (!this.bonbons.length) {
        this.grilleVide.textContent =
          window.Shopify && window.Shopify.designMode
            ? 'Aucun bonbon : ajoutez des blocs « Famille » ou choisissez une collection dans les réglages de la section.'
            : 'Les bonbons arrivent très vite, reviens dans un instant !';
      } else if (recherche) {
        this.grilleVide.textContent = 'Aucun bonbon ne correspond à ta recherche.';
      } else {
        this.grilleVide.textContent = 'Aucun bonbon ne correspond à ces filtres. Remets-en un sur « Tout ».';
      }
    }

    variante() {
      const format = this.format(this.etat.formatId);
      return (format && format.variantes.find((v) => v.id === this.etat.varianteId)) || null;
    }

    estEnCases() {
      const format = this.format(this.etat.formatId);
      return Boolean(format && format.mode === 'cases');
    }

    capacite() {
      const format = this.format(this.etat.formatId);
      if (!format) return 0;
      if (format.mode === 'cases') return format.cases;

      return Math.max(1, Math.floor(this.grammesContenant() / this.pas));
    }

    grammesContenant() {
      const format = this.format(this.etat.formatId);
      if (!format) return 0;

      const variante = this.variante();
      return grammesDans(variante && variante.titre) || grammesDans(format.titreProduit) || format.contenance;
    }

    prises(index = this.etat.actif) {
      const mix = this.etat.contenants[index];
      let total = 0;
      if (mix) mix.forEach((n) => { total += n; });
      return total;
    }

    varietesMin() {
      return Math.min(this.varietesMinimum, this.capacite());
    }

    manque() {
      const capacite = this.capacite();
      const prises = this.prises();
      const enCases = this.estEnCases();

      const maxVarietes = this.compartiments();
      if (maxVarietes && this.etat.bonbons.size > maxVarietes) {
        return 'Retire ' + pluriel(this.etat.bonbons.size - maxVarietes, 'bonbon différent', 'bonbons différents');
      }
      if (prises > capacite) return 'Retire ' + pluriel(prises - capacite, 'bonbon', 'bonbons');
      if (prises < capacite) {
        return 'Encore ' + pluriel(capacite - prises, enCases ? 'case' : 'bonbon', enCases ? 'cases' : 'bonbons');
      }

      const varietes = this.varietesMin() - this.etat.bonbons.size;
      if (varietes > 0) return 'Encore ' + pluriel(varietes, 'bonbon différent', 'bonbons différents');

      return '';
    }

    libellePortions(n) {
      return this.estEnCases() ? '×' + n : (n * this.pas).toLocaleString('fr-FR') + ' g';
    }

    pointDuTas(taille) {
      const svg = this.tasSvg();
      if (!svg) return null;
      const forme = this.formes && this.formes[svg.dataset.forme];
      if (!forme) return null;
      const n = forme.trous.length;
      const capacite = this.capacite() || 1;
      const avant = Math.max(0, Math.min(n, Math.round((this.prises() / capacite) * n)));
      const apres = Math.max(0, Math.min(n, Math.round(((this.prises() + 1) / capacite) * n)));
      if (apres <= avant) return null;

      let sx = 0;
      let sy = 0;
      for (let i = avant; i < apres; i += 1) {
        sx += forme.trous[i][0];
        sy += forme.trous[i][1];
      }
      const nb = apres - avant;

      const vx = sx / nb;
      const vy = sy / nb - 20;

      const r = svg.getBoundingClientRect();
      if (!r.width || !r.height) return null;
      const k = r.width / 200;
      const cx = r.x + (vx + 100) * k;
      const cy = r.y + (vy + 100) * (r.height / 200);

      return { x: cx - taille / 2, y: cy - taille * 0.58, width: taille, height: taille };
    }

    cibleDuVol() {
      const visuels = this.querySelector('[data-cm-pmx-visuels]');
      if (!visuels || visuels.hidden) return null;

      return (
        visuels.querySelector('.cm-pmx__anneau-carte[data-pos="0"]') ||
        visuels.querySelector('.cm-pmx__resume-img:not(.cm-pmx__resume-img--cote)') ||
        visuels
      );
    }

    impactContenant() {
      const cible = this.cibleDuVol();
      if (!cible || this.mouvementReduit()) return;

      if (cible.classList.contains('cm-pmx__anneau-carte')) {
        cible.animate(
          [
            { transform: 'scale(1, 1)', easing: 'ease-out' },
            { transform: 'scale(1.06, 0.93)', offset: 0.22, easing: 'ease-in-out' },
            { transform: 'scale(0.975, 1.045)', offset: 0.48, easing: 'ease-in-out' },
            { transform: 'scale(1.015, 0.985)', offset: 0.74, easing: 'ease-in-out' },
            { transform: 'scale(1, 1)' },
          ],

          { duration: 420, easing: 'linear', composite: 'add' }
        );
        return;
      }
      cible.classList.remove('est-impact');
      void cible.offsetWidth;
      cible.classList.add('est-impact');

      cible.addEventListener(
        'animationend',
        (evt) => {
          if (evt.animationName === 'cm-pmx-impact') cible.classList.remove('est-impact');
        },
        { once: true }
      );
    }

    mouvementReduit() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    volVers(id, { retour = false, retard = 0 } = {}) {
      if (this.mouvementReduit()) return 0;
      if (volsEnCours >= VOL_MAX) return 0;

      const entree = this.cartes && this.cartes.get(id);
      const cible = this.cibleDuVol();
      if (!entree || !cible) return 0;

      const source = entree.carte.querySelector('.cm-pmx__bonbon-img');
      if (!source || !source.currentSrc) return 0;

      const a = source.getBoundingClientRect();
      const b = cible.getBoundingClientRect();

      const h = window.innerHeight || 0;
      const w = window.innerWidth || 0;
      if (!a.width || !b.width) return 0;
      if (a.bottom < 0 || a.top > h || a.right < 0 || a.left > w) return 0;

      const taille = Math.round(Math.min(104, Math.max(40, a.width * 0.46)));
      const depart = retour ? b : a;
      const vise = retour ? null : this.pointDuTas(taille);
      const arrivee = retour ? a : (vise || b);
      const x0 = depart.x + depart.width / 2 - taille / 2;
      const y0 = depart.y + depart.height * (retour ? 0.58 : 0.5) - taille / 2;
      const x1 = arrivee.x + arrivee.width / 2 - taille / 2;
      const y1 = arrivee.y + arrivee.height * (retour ? 0.5 : 0.58) - taille / 2;

      const hote = this.querySelector('[data-cm-pmx-visuels]') || document.body;
      const rh = hote === document.body ? { x: 0, y: 0, width: 0, height: 0 } : hote.getBoundingClientRect();

      const ex = hote.offsetWidth ? rh.width / hote.offsetWidth : 1;
      const ey = hote.offsetHeight ? rh.height / hote.offsetHeight : 1;
      const locX = (X) => (X - rh.x) / (ex || 1);
      const locY = (Y) => (Y - rh.y) / (ey || 1);

      const disque = document.createElement('span');
      disque.className = 'cm-pmx__vol';
      disque.setAttribute('aria-hidden', 'true');
      disque.style.width = taille + 'px';
      disque.style.height = taille + 'px';
      disque.style.backgroundImage = 'url("' + source.currentSrc + '")';
      hote.appendChild(disque);
      volsEnCours += 1;

      const lx0 = locX(x0);
      const ly0 = locY(y0);
      const lx1 = locX(x1);
      const ly1 = locY(y1);
      const dx = lx1 - lx0;
      const dy = ly1 - ly0;
      const distance = Math.hypot(dx, dy);
      const duree = Math.min(VOL_MAX_MS, Math.max(VOL_MIN, VOL_BASE + VOL_PENTE * distance));

      const recouvre = Math.min(VOL_RECOUVRE, duree * 0.18);
      const ampli = Math.min(150, Math.max(60, distance * 0.26));
      const cx = lx0 + dx * 0.5;

      const cy = Math.max(locY(10), (ly0 + ly1) / 2 - ampli);

      const images = [];
      for (let i = 0; i <= 14; i += 1) {
        const t = i / 14;
        const u = 1 - t;
        const x = u * u * lx0 + 2 * u * t * cx + t * t * lx1;
        const y = u * u * ly0 + 2 * u * t * cy + t * t * ly1;

        const echelle = retour ? 0.48 + 0.52 * t : 1 - 0.52 * t;

        const opacite = retour ? (t < 0.2 ? t / 0.2 : 1) : t < 0.985 ? 1 : 0;
        images.push({
          transform:
            'translate3d(' + x + 'px,' + y + 'px,0) scale(' + echelle + ') rotate(' + 300 * t + 'deg)',
          opacity: opacite,
        });
      }

      const anim = disque.animate(images, {
        duration: duree,
        delay: retard,
        easing: 'cubic-bezier(.34,.02,.28,1)',
        fill: 'both',
      });

      const nettoyer = () => {
        if (!disque.isConnected) return;
        disque.remove();
        volsEnCours = Math.max(0, volsEnCours - 1);
      };
      anim.finished.then(nettoyer, nettoyer);

      window.setTimeout(nettoyer, duree + retard + 900);

      return Math.max(0, duree + retard - recouvre);
    }

    volEtImpact(id, options) {
      const delai = this.volVers(id, options);
      if (!delai) return;

      this.delaiCase = delai;
      window.setTimeout(() => this.impactContenant(), delai);
    }

    ajouter(id) {
      if (!this.bonbonParId.has(id)) return;

      if (this.prises() >= this.capacite()) {
        this.statut(
          this.estEnCases()
            ? 'Toutes les cases sont prises. Retire un bonbon pour en changer.'
            : 'Ton contenant est plein. Retire un bonbon pour en ajouter un autre.',
          { erreur: true }
        );
        return;
      }

      const maxVarietes = this.compartiments();
      if (maxVarietes && !this.etat.bonbons.has(id) && this.etat.bonbons.size >= maxVarietes) {
        const tc = this.tonContenant();
        this.statut(
          tc.charAt(0).toUpperCase() + tc.slice(1) + ' a ' + maxVarietes +
            ' compartiments, et chacun a déjà son bonbon. Ajoute ' + this.pas.toLocaleString('fr-FR') +
            ' g à l’un d’eux avec le +, ou retire un bonbon pour en changer.',
          { erreur: true }
        );
        return;
      }

      this.volEtImpact(id);

      this.etat.bonbons.set(id, (this.etat.bonbons.get(id) || 0) + 1);
      this.apresRetouche(id);
    }

    retirer(id, tout = false) {
      const n = this.etat.bonbons.get(id) || 0;
      if (!n) return;

      this.volVers(id, { retour: true });

      if (tout || n === 1) this.etat.bonbons.delete(id);
      else this.etat.bonbons.set(id, n - 1);

      this.apresRetouche(id);
    }

    apresRetouche(id) {
      this.etat.hasard = new Map();
      this.annulation = null;
      this.majCarte(id);
      this.statut('');
      this.majResume();
      this.majContenant();
    }

    retirerIncompatibles({ muet = false } = {}) {

      let nRegime = 0;
      let nFormat = 0;
      this.etat.contenants.forEach((contenant, i) => {
        [...contenant.keys()].forEach((id) => {
          const b = this.bonbonParId.get(id);
          if (b && this.compatible(b)) return;

          const horsRegime = !b || !this.etat.regime || !b.regles.includes(this.etat.regime);
          if (horsRegime) {
            nRegime++;
          } else {
            nFormat++;
          }

          contenant.delete(id);
          this.etat.hasards[i].delete(id);
          if (i === this.etat.actif) this.majCarte(id);
        });
      });

      const n = nRegime + nFormat;
      if (!n) return 0;

      if (!muet) this.statut(this.phraseRetrait(nRegime, nFormat));
      return n;
    }

    majCarte(id) {
      const c = this.cartes && this.cartes.get(id);
      if (!c) return;

      const n = this.etat.bonbons.get(id) || 0;
      c.carte.classList.toggle('is-choisi', n > 0);
      c.retrait.hidden = !n;
      c.dosage.hidden = !n;
      c.invite.hidden = n > 0;
      c.valeur.textContent = n ? this.libellePortions(n) : '';
    }

    majResume() {
      const format = this.format(this.etat.formatId);
      const variante = this.variante();
      if (!format || !variante) return;

      const capacite = this.capacite();
      const prises = this.prises();
      const enCases = this.estEnCases();

      const quantite = this.etat.quantite;
      const resume = this.querySelector('.cm-pmx__resume');
      const visuels = this.querySelector('[data-cm-pmx-visuels]');
      visuels.hidden = !format.image;
      if (format.image) {
        this.querySelectorAll('[data-cm-pmx-resume-img]').forEach((img) => {
          if (img.getAttribute('src') !== format.image) img.src = format.image;
        });
      }
      resume.classList.toggle('a-deux', quantite >= 2);
      resume.classList.toggle('a-trois', quantite >= 3);
      resume.classList.toggle('a-quatre', quantite >= 4);
      this.querySelector('[data-cm-pmx-multiple]').textContent = '×' + quantite;

      this.querySelector('[data-cm-pmx-quantite]').textContent = quantite;
      this.querySelector('[data-cm-pmx-quantite-moins]').disabled = quantite <= 1;
      this.querySelector('[data-cm-pmx-quantite-plus]').disabled = quantite >= QUANTITE_MAX;

      let taille;
      if (enCases) taille = pluriel(capacite, 'case', 'cases');
      else if (variante.titre !== 'Default Title') taille = variante.titre;
      else taille = poidsLisible(this.grammesContenant());

      const nom = this.querySelector('[data-cm-pmx-resume-nom]');
      nom.textContent = format.nom + ' ';
      nom.appendChild(element('span', 'cm-pmx__resume-taille', '· ' + taille));

      const legende = this.querySelector('[data-cm-pmx-legende]');
      if (legende) {
        legende.textContent = format.nom + ' ';
        legende.appendChild(element('span', 'cm-pmx__resume-taille', '· ' + taille));
      }
      this.querySelector('[data-cm-pmx-resume-prix]').textContent = this.prixTotal(variante);

      this.majAnneau();

      this.dessinerChoix(this.querySelector('[data-cm-pmx-choix]'), false);

      const boutonRecap = this.querySelector('[data-cm-pmx-recap]');
      if (boutonRecap) boutonRecap.disabled = !this.etat.bonbons.size;
      const plusieurs = this.etat.contenants.length > 1;
      this.querySelectorAll('[data-cm-pmx-tout-retirer]').forEach((bouton) => {
        bouton.hidden = !this.etat.bonbons.size;
        bouton.setAttribute('aria-label', plusieurs ? 'Vider ' + this.nomContenant(this.etat.actif) : 'Vider ta sélection');
      });

      const zoneContenants = this.querySelector('[data-cm-pmx-contenants-zone]');
      const onglets = this.querySelector('[data-cm-pmx-contenants]');
      zoneContenants.hidden = !plusieurs;
      onglets.textContent = '';
      this.etat.contenants.forEach((contenant, i) => {
        let portions = 0;
        contenant.forEach((n) => {
          portions += n;
        });
        const complet = portions === capacite && contenant.size >= this.varietesMin();

        const onglet = element(
          'button',
          'cm-pmx__onglet' + (i === this.etat.actif ? ' is-actif' : '') + (complet ? ' is-plein' : ''),
          String(i + 1)
        );
        onglet.type = 'button';
        onglet.dataset.cmPmxActiver = i;
        onglet.setAttribute('aria-pressed', String(i === this.etat.actif));
        onglet.setAttribute(
          'aria-label',
          this.nomContenant(i) + ' : ' + portions + ' sur ' + capacite + (complet ? ', complet' : '')
        );
        onglets.appendChild(onglet);
      });
      if (this.recap && this.recap.open) this.dessinerRecap();

      const cible = enCases ? pluriel(capacite, 'case', 'cases') : pluriel(capacite, 'bonbon', 'bonbons');
      const pourcentage = Math.min(100, Math.round((prises / capacite) * 100));

      this.querySelector('[data-cm-pmx-jauge-prises]').textContent = prises;
      this.querySelector('[data-cm-pmx-jauge-cible]').textContent = '/ ' + cible;
      this.querySelector('[data-cm-pmx-jauge-varietes]').textContent = pluriel(this.etat.bonbons.size, 'variété', 'variétés');

      const jauge = this.querySelector('[data-cm-pmx-jauge]');
      jauge.setAttribute('aria-valuenow', String(pourcentage));
      jauge.setAttribute('aria-valuetext', prises + ' sur ' + cible);
      jauge.classList.toggle('is-deborde', prises > capacite);
      this.querySelector('[data-cm-pmx-jauge-barre]').style.width = pourcentage + '%';

      const maxVarietes = this.compartiments();
      this.grille.classList.toggle(
        'is-plein',
        prises >= capacite || Boolean(maxVarietes && this.etat.bonbons.size >= maxVarietes)
      );
      this.majFil();
    }

    dessinerChoix(liste, grand, index = this.etat.actif) {
      if (!liste) return;

      const contenant = this.etat.contenants[index];
      const hasard = this.etat.hasards[index];

      liste.textContent = '';
      liste.dataset.cmPmxDans = index;
      liste.classList.toggle('is-liste', this.etat.vue === 'liste');

      if (!contenant.size) {
        liste.appendChild(
          element(
            'li',
            'cm-pmx__choix-vide',
            grand
              ? 'Ce contenant est encore vide : touche un bonbon dans la grille pour commencer.'
              : 'Touche un bonbon pour le mettre dans ton contenant.'
          )
        );
        return;
      }

      contenant.forEach((n, id) => {
        const b = this.bonbonParId.get(id);
        if (!b) return;

        const tire = hasard.has(id);
        const li = element('li', 'cm-pmx__choix-item' + (tire ? ' is-hasard' : ''));
        if (tire) li.title = 'Tiré au hasard';

        if (b.image) {
          const img = element('img', 'cm-pmx__choix-img');
          img.src = b.image;
          img.alt = '';
          img.width = grand ? 240 : 56;
          img.height = grand ? 240 : 56;
          img.loading = 'lazy';
          li.appendChild(img);
        } else {
          li.appendChild(element('span', 'cm-pmx__choix-img cm-pmx__bonbon-sans-image', '🍬'));
        }

        const texte = element('div', 'cm-pmx__choix-texte');
        texte.appendChild(element('span', 'cm-pmx__choix-nom', b.titre));

        if (grand) {
          const dosage = element('div', 'cm-pmx__dosage');

          const moins = element('button', '', '−');
          moins.type = 'button';
          moins.dataset.cmPmxMoins = id;
          moins.setAttribute('aria-label', 'Une portion de moins : ' + b.titre);

          const plus = element('button', '', '+');
          plus.type = 'button';
          plus.dataset.cmPmxPlus = id;
          plus.setAttribute('aria-label', 'Une portion de plus : ' + b.titre);

          dosage.append(moins, element('span', 'cm-pmx__dosage-valeur', this.libellePortions(n)), plus);
          texte.appendChild(dosage);
        }
        li.appendChild(texte);

        if (!grand) li.appendChild(element('span', 'cm-pmx__choix-dose', this.libellePortions(n)));

        const croix = element('button', 'cm-pmx__choix-retrait', '×');
        croix.type = 'button';
        croix.dataset.cmPmxVider = id;
        croix.setAttribute('aria-label', 'Retirer ' + b.titre);
        li.appendChild(croix);

        liste.appendChild(li);
      });
    }

    choisirVue(vue) {
      this.etat.vue = vue === 'liste' ? 'liste' : 'grille';

      this.querySelectorAll('[data-cm-pmx-vue]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn.dataset.cmPmxVue === this.etat.vue));
      });
      this.querySelectorAll('.cm-pmx__choix').forEach((liste) => {
        liste.classList.toggle('is-liste', this.etat.vue === 'liste');
      });
    }

    ouvrirRecap() {
      if (!this.recap || !this.etat.bonbons.size) return;
      this.dessinerRecap();
      if (!this.recap.open) this.recap.showModal();
    }

    dessinerRecap() {
      const format = this.format(this.etat.formatId);
      const variante = this.variante();
      if (!this.recap || !format || !variante) return;

      const actif = this.recap.contains(document.activeElement) ? document.activeElement : null;
      const attribut = actif && actif.getAttributeNames().find((nom) => /^data-cm-pmx-(plus|moins|vider)$/.test(nom));
      const groupe = attribut && actif.closest('[data-cm-pmx-dans]');
      const selecteur = attribut
        ? (groupe ? `[data-cm-pmx-dans="${groupe.dataset.cmPmxDans}"] ` : '') +
          `[${attribut}="${actif.getAttribute(attribut)}"]`
        : null;

      const img = this.recap.querySelector('[data-cm-pmx-recap-img]');
      img.hidden = !format.image;
      if (format.image) img.src = format.image;

      const fois = this.etat.quantite > 1 ? ' · ×' + this.etat.quantite : '';
      this.recap.querySelector('[data-cm-pmx-recap-nom]').textContent =
        this.querySelector('[data-cm-pmx-resume-nom]').textContent + fois;
      this.recap.querySelector('[data-cm-pmx-recap-prix]').textContent = this.prixTotal(variante);

      const capacite = this.capacite();
      const cible = this.estEnCases() ? pluriel(capacite, 'case', 'cases') : pluriel(capacite, 'bonbon', 'bonbons');
      const plusieurs = this.etat.contenants.length > 1;

      this.recap.querySelector('.cm-pmx__recap-titre').textContent = plusieurs ? 'Tes mix' : 'Ton mix';
      this.recap.querySelector('[data-cm-pmx-recap-compte]').textContent = plusieurs
        ? pluriel(this.etat.contenants.length, 'contenant', 'contenants') + ' de ' + cible
        : this.prises() + ' / ' + cible + ' · ' + pluriel(this.etat.bonbons.size, 'variété', 'variétés');

      const zone = this.recap.querySelector('[data-cm-pmx-recap-liste]');
      zone.textContent = '';
      this.etat.contenants.forEach((contenant, i) => {
        const groupe = element('section', 'cm-pmx__recap-groupe');

        if (plusieurs) {
          let portions = 0;
          contenant.forEach((n) => {
            portions += n;
          });
          const titre = element('h5', 'cm-pmx__recap-groupe-titre', this.nomContenant(i));
          titre.appendChild(element('span', '', portions + ' / ' + cible));
          groupe.appendChild(titre);
        }

        const liste = element('ul', 'cm-pmx__choix cm-pmx__choix--grand');
        liste.setAttribute('role', 'list');
        liste.setAttribute('aria-label', 'Bonbons de ' + this.nomContenant(i));
        this.dessinerChoix(liste, true, i);
        groupe.appendChild(liste);
        zone.appendChild(groupe);
      });

      if (selecteur) {
        const retrouve = this.recap.querySelector(selecteur);
        (retrouve || this.recap.querySelector('[data-cm-pmx-recap-fermer]')).focus();
      }
    }

    statut(texte, { erreur = false, annulable = false } = {}) {
      this.querySelectorAll('[data-cm-pmx-statut], [data-cm-pmx-recap-statut]').forEach((zone) => {
        zone.textContent = texte;
        zone.classList.toggle('is-erreur', erreur);

        if (annulable) {
          const bouton = element('button', 'cm-pmx__statut-annuler', 'Annuler');
          bouton.type = 'button';
          bouton.dataset.cmPmxAnnuler = '';
          zone.append(' ', bouton);
        }
      });
    }

    async valider(bouton) {
      if (this.envoiEnCours) return;

      const plusieurs = this.etat.contenants.length > 1;
      const capacite = this.capacite();
      const maxVarietes = this.compartiments();
      const bloquant = this.etat.contenants.findIndex((contenant) => {
        let portions = 0;
        contenant.forEach((n) => {
          portions += n;
        });
        return (
          (plusieurs && !contenant.size) ||
          portions > capacite ||
          Boolean(maxVarietes && contenant.size > maxVarietes)
        );
      });

      if (bloquant >= 0) {
        this.activerContenant(bloquant);
        const prefixe = plusieurs ? this.nomContenant(bloquant) + ' : ' : '';
        this.statut(
          this.etat.bonbons.size
            ? prefixe + this.manque() + ' pour pouvoir valider.'
            : prefixe + 'encore vide. Choisis ses bonbons, ou laisse faire « Mix aléatoire ».',
          { erreur: true }
        );
        return;
      }

      let ajoutees = 0;
      for (let i = 0; i < this.etat.contenants.length; i++) {
        this.activerContenant(i);

        if (this.prises() < capacite) {
          const complement = this.completerAuHasard();
          if (!complement) return;
          ajoutees += complement;
        }

        const manque = this.manque();
        if (manque) {
          this.statut((plusieurs ? this.nomContenant(i) + ' : ' : '') + manque + ' pour pouvoir valider.', { erreur: true });
          return;
        }
      }

      if (ajoutees) {
        this.statut(pluriel(ajoutees, 'bonbon ajouté', 'bonbons ajoutés') + ' au hasard pour compléter (★).');
      }

      await this.ajouterAuPanier(bouton || this.querySelector('[data-cm-pmx-valider]'));
    }

    async ajouterAuPanier(bouton) {

      const libelle = bouton.innerHTML;
      this.envoiEnCours = true;
      bouton.disabled = true;
      bouton.textContent = 'Ajout au panier…';

      const sections = ['cart-icon-bubble'];
      const tiroir = document.querySelector('cart-drawer');
      const sectionTiroir = tiroir && tiroir.closest('.shopify-section');
      if (sectionTiroir) sections.push(sectionTiroir.id.replace('shopify-section-', ''));

      const routes = (window.theme && window.theme.routes) || {};
      const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const adresse = (routes.cartAdd || racine + 'cart/add') + '.js';

      try {
        const reponse = await fetch(adresse, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({

            items: this.etat.contenants.flatMap((contenant, i) => {
              const lignes = [{
                id: this.etat.varianteId,
                quantity: 1,
                properties: this.proprietes(contenant),
              }];
              this.supplementsDe(contenant).forEach((g, palier) => {
                lignes.push({
                  id: g.id,
                  quantity: g.portions,
                  properties: {
                    'Supplément pour': this.etat.contenants.length > 1 ? this.nomContenant(i) : this.nomContenant(0),
                    Bonbons: g.libelles.join(', '),
                    _cm_sup: i + ':' + palier,
                  },
                });
              });
              return lignes;
            }),
            sections: sections.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const donnees = await reponse.json();
        if (!reponse.ok) throw new Error(donnees.description || donnees.message || 'HTTP ' + reponse.status);

        if (this.recap && this.recap.open) this.recap.close();
        this.etat.ajoute = true;
        this.allerA(4);
        this.annonce(this.messageAjout());
        this.rafraichirPanier(donnees, tiroir);
      } catch (erreur) {
        this.statut("Ton mix n'a pas pu être ajouté au panier. " + erreur.message, { erreur: true });
      } finally {
        this.envoiEnCours = false;
        bouton.disabled = false;
        bouton.innerHTML = libelle;
      }
    }

    proprietes(contenant = this.etat.bonbons) {
      const lignes = [...contenant].map(([id, n]) => {
        const b = this.bonbonParId.get(id);
        const nom = b ? b.titre.replace(/\s*\(\s*\d+\s*g\s*\)\s*$/i, '') : String(id);
        return nom + ' ' + this.libellePortions(n);
      });

      const proprietes = { Bonbons: lignes.join(', ') };
      const regime = this.regimes.find((r) => r.id === this.etat.regime);
      if (regime) proprietes['Régime'] = regime.nom;
      proprietes._composition = JSON.stringify([...contenant]);

      return proprietes;
    }

    rafraichirPanier(donnees, tiroir) {
      try {
        const bulle = document.getElementById('cart-icon-bubble');
        if (bulle && donnees.sections && donnees.sections['cart-icon-bubble']) {
          bulle.innerHTML = donnees.sections['cart-icon-bubble'];
        }

        if (tiroir && typeof tiroir.renderContents === 'function') {
          Promise.resolve(tiroir.renderContents(donnees, true)).catch((erreur) => {
            console.warn('[cm-pickmix] tiroir panier non rafraîchi', erreur);
          });
        }
        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: this.etat.varianteId } }));
      } catch (erreur) {
        console.warn('[cm-pickmix] panier ajouté, mais affichage non rafraîchi', erreur);
      }
    }

    annonce(texte) {
      const zone = this.querySelector('[data-cm-pmx-annonce]');
      if (zone) zone.textContent = texte;
    }

    recommencer() {
      const anciens = [...this.etat.bonbons.keys()];

      Object.assign(this.etat, {
        formatId: null,
        varianteId: null,
        famille: null,
        couleur: null,
        recherche: '',
        contenants: [new Map()],
        hasards: [new Map()],
        actif: 0,
        plusLoin: 1,
        ajoute: false,
        quantite: 1,
      });
      this.annulation = null;
      anciens.forEach((id) => this.majCarte(id));

      this.querySelectorAll('[data-cm-pmx-format]').forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
      this.masquerTailles();
      this.majBoutonSuivant();

      const recherche = this.querySelector('[data-cm-pmx-recherche]');
      if (recherche) recherche.value = '';
      const famille = this.querySelector('[data-cm-pmx-tri-famille]');
      if (famille) famille.value = '';
      const couleur = this.querySelector('[data-cm-pmx-tri-couleur]');
      if (couleur) couleur.value = '';

      this.choisirRegime('');
      this.statut('');
      this.allerA(1);
      this.annonce('Nouvelle boîte : choisis ton contenant.');
    }

    melangeAleatoire() {
      const capacite = this.capacite();
      if (!capacite) return;

      if (this.prises() >= capacite) {
        if (!this.etat.hasard.size) {
          this.statut('Ton contenant est déjà plein. Retire un bonbon pour laisser le hasard choisir.', { erreur: true });
          return;
        }
        this.rendreHasard();
      }

      if (this.prises() >= capacite) {
        this.statut(this.manque() + ' pour faire de la place.', { erreur: true });
        return;
      }

      if (this.completerAuHasard()) {
        this.statut('Mix complété au hasard (★). Appuie encore pour un autre tirage.');
      }
    }

    completerAuHasard() {
      const libres = this.capacite() - this.prises();
      if (libres <= 0) return 0;

      const maxVarietes = this.compartiments();
      const nouveaux = maxVarietes ? Math.max(0, maxVarietes - this.etat.bonbons.size) : libres;
      const cibles = melanger(this.bonbons.filter((b) => this.compatible(b) && !this.etat.bonbons.has(b.id)))
        .slice(0, Math.min(libres, nouveaux))
        .map((b) => b.id);

      if (!cibles.length) cibles.push(...melanger([...this.etat.bonbons.keys()]));
      if (!cibles.length) {
        this.statut('Aucun bonbon compatible à tirer au hasard.', { erreur: true });
        return 0;
      }

      const tirage = new Map();
      for (let i = 0; i < libres; i++) {
        const id = cibles[i % cibles.length];
        tirage.set(id, (tirage.get(id) || 0) + 1);
      }

      tirage.forEach((n, id) => {
        this.etat.bonbons.set(id, (this.etat.bonbons.get(id) || 0) + n);
        this.etat.hasard.set(id, (this.etat.hasard.get(id) || 0) + n);
        this.majCarte(id);
      });

      this.annulation = null;
      this.majResume();
      this.majContenant();
      return libres;
    }

    rendreHasard() {
      this.etat.hasard.forEach((n, id) => {
        const reste = (this.etat.bonbons.get(id) || 0) - n;
        if (reste > 0) this.etat.bonbons.set(id, reste);
        else this.etat.bonbons.delete(id);
        this.majCarte(id);
      });
      this.etat.hasard = new Map();
    }

    appliquerMix(id) {
      const mix = this.mixes.find((m) => m.id === id);
      const capacite = this.capacite();
      if (!mix || !capacite) return;

      const vivier = melanger(this.bonbons.filter((b) => this.compatible(b) && b.regles.includes(id)));
      if (!vivier.length) {
        this.statut('Aucun bonbon ne correspond à « ' + mix.nom + ' » avec ce régime.', { erreur: true });
        return;
      }

      const avant = new Map(this.etat.bonbons);

      const choisis = vivier.slice(0, Math.min(capacite, this.compartiments() || capacite));
      const selection = new Map();
      for (let i = 0; i < capacite; i++) {
        const bid = choisis[i % choisis.length].id;
        selection.set(bid, (selection.get(bid) || 0) + 1);
      }

      this.etat.bonbons = selection;
      this.etat.hasard = new Map();
      const index = this.etat.actif;
      this.annulation = avant.size ? () => this.restaurer(index, avant) : null;

      new Set([...avant.keys(), ...selection.keys()]).forEach((bid) => this.majCarte(bid));
      this.majResume();
      this.majContenant();

      this.impactContenant();
      this.statut('Mix « ' + mix.nom + ' » appliqué.', { annulable: avant.size > 0 });
    }

    annuler() {
      if (!this.annulation) return;

      const retour = this.annulation;
      this.annulation = null;
      retour();
      this.statut('Ta sélection précédente est revenue.');
    }

    restaurer(index, contenant) {
      this.etat.contenants[index] = contenant;
      this.etat.hasards[index] = new Map();
      this.etat.actif = index;
      this.majCartes();
      this.majResume();
      this.majContenant();
    }

    toutRetirer() {
      if (!this.etat.bonbons.size) return;

      const avant = this.etat.bonbons;
      const index = this.etat.actif;
      this.etat.bonbons = new Map();
      this.etat.hasard = new Map();
      this.annulation = () => this.restaurer(index, avant);

      avant.forEach((n, id) => this.majCarte(id));
      this.majResume();
      this.majContenant();
      this.statut('Ta sélection est vidée.', { annulable: true });
    }

    changerQuantite(ecart) {
      const quantite = Math.min(QUANTITE_MAX, Math.max(1, this.etat.contenants.length + ecart));
      if (quantite === this.etat.contenants.length) return;

      this.annulation = null;

      if (ecart > 0) {
        this.etat.contenants.push(new Map());
        this.etat.hasards.push(new Map());
        this.etat.actif = this.etat.contenants.length - 1;
        this.statut(this.nomContenant(this.etat.actif) + ' : choisis ses bonbons dans la grille.');
      } else {
        const index = this.etat.contenants.length - 1;
        const contenant = this.etat.contenants.pop();
        const hasard = this.etat.hasards.pop();
        this.etat.actif = Math.min(this.etat.actif, this.etat.contenants.length - 1);

        if (contenant.size) {
          this.annulation = () => {
            this.etat.contenants.splice(index, 0, contenant);
            this.etat.hasards.splice(index, 0, hasard);
            this.etat.quantite = this.etat.contenants.length;
            this.etat.actif = index;
            this.majCartes();
            this.majResume();
            this.majContenant();
          };
          this.statut('Contenant retiré : ' + this.nomContenant(index) + ' et ses bonbons.', { annulable: true });
        } else {
          this.statut('');
        }
      }

      this.etat.quantite = this.etat.contenants.length;
      this.majCartes();
      this.majResume();
      this.majContenant();

      const visuels = this.querySelector('[data-cm-pmx-visuels]');
      visuels.classList.remove('is-rebond');
      void visuels.offsetWidth;
      visuels.classList.add('is-rebond');
    }

    activerContenant(index) {
      if (index === this.etat.actif || !this.etat.contenants[index]) return;

      this.etat.actif = index;
      this.annulation = null;
      this.majCartes();
      this.statut('');
      this.majResume();
      this.majContenant();
    }

    majCartes() {
      if (!this.cartes) return;
      this.cartes.forEach((carte, id) => this.majCarte(id));
    }

    nomContenant(index) {
      const format = this.format(this.etat.formatId);
      return (format ? format.nom : 'Contenant') + ' ' + (index + 1);
    }

    messageAjout() {
      const format = this.format(this.etat.formatId);
      const n = this.etat.contenants.length;
      const feminin = Boolean(format && format.genre === 'f');
      const singulier = ((format && (format.nomPhrase || format.nom)) || 'contenant').toLowerCase();
      const pluriels = ((format && format.nomPluriel) || singulier + 's').toLowerCase();
      const accord = feminin ? 'ajoutée' : 'ajouté';

      return n > 1
        ? 'Tes ' + n + ' ' + pluriels + ' sont ' + accord + 's au panier.'
        : (feminin ? 'Ta ' : 'Ton ') + singulier + ' est ' + accord + ' au panier.';
    }

    supplementsDe(contenant) {
      const parPalier = new Map();
      contenant.forEach((portions, id) => {
        const b = this.bonbonParId.get(id);
        if (!b || !b.sup) return;
        const cle = b.sup.p;
        const g = parPalier.get(cle) || { id: b.sup.id, portions: 0, centimes: b.sup.c, libelles: [] };
        g.portions += portions;
        g.libelles.push(b.titre + (portions > 1 ? ' × ' + portions : ''));
        parPalier.set(cle, g);
      });
      return parPalier;
    }

    supplementCentimes() {
      let total = 0;
      this.etat.contenants.forEach((contenant) => {
        this.supplementsDe(contenant).forEach((g) => { total += g.centimes * g.portions; });
      });
      return total;
    }

    prixTotal(variante) {
      const n = this.etat.contenants.length;
      const centimes = variante.prix * n + this.supplementCentimes();
      return prixMultiplie(variante.prixFormate, centimes, 1);
    }

    majPropositions() {
      const compatibles = this.bonbons.filter((b) => this.compatible(b));

      let mixVisibles = 0;
      this.querySelectorAll('[data-cm-pmx-mix]').forEach((bouton) => {
        const possible = compatibles.some((b) => b.regles.includes(bouton.dataset.cmPmxMix));
        (bouton.closest('li') || bouton).hidden = !possible;
        if (possible) mixVisibles++;
      });

      const zoneMix = this.querySelector('.cm-pmx__express');
      if (zoneMix) zoneMix.hidden = mixVisibles === 0;

      [
        ['[data-cm-pmx-tri-famille]', 'familles', 'famille'],
        ['[data-cm-pmx-tri-couleur]', 'couleurs', 'couleur'],
      ].forEach(([selecteur, cle, champ]) => {
        const liste = this.querySelector(selecteur);
        if (!liste) return;

        [...liste.options].forEach((option) => {
          if (option.value) option.disabled = !compatibles.some((b) => b[cle].includes(option.value));
        });

        if (liste.selectedOptions[0] && liste.selectedOptions[0].disabled) {
          liste.value = '';
          this.etat[champ] = null;
        }
      });
    }

    async ouvrirFiche(id) {
      const b = this.bonbonParId.get(id);
      if (!b || !this.fiche) return;

      const outil = window.CmEtiquette;
      const corps = this.fiche.querySelector('[data-cm-pmx-etiq-corps]');
      const nom = this.fiche.querySelector('[data-cm-pmx-etiq-nom]');

      if (nom) nom.textContent = b.titre;
      const vignette = this.fiche.querySelector('[data-cm-pmx-etiq-vignette]');
      if (vignette) {
        if (b.image) { vignette.src = b.image; vignette.hidden = false; }
        else { vignette.removeAttribute('src'); vignette.hidden = true; }
      }
      ['[data-cm-pmx-etiq-marque]', '[data-cm-pmx-etiq-regimes]'].forEach((sel) => {
        const n = this.fiche.querySelector(sel);
        if (n) { n.textContent = ''; n.hidden = true; }
      });
      const denom = this.fiche.querySelector('[data-cm-pmx-etiq-denom]');
      if (denom) denom.textContent = '';
      const sante = this.fiche.querySelector('[data-cm-pmx-etiq-sante]');
      if (sante) sante.textContent = '';
      if (corps) corps.textContent = 'Je déplie l’étiquette…';

      this.ficheOuverte = id;
      if (!this.fiche.open) this.fiche.showModal();
      const zone = this.fiche.querySelector('[data-cm-pmx-etiq-defile]');
      if (zone) zone.scrollTop = 0;

      this.etiquettes = this.etiquettes || new Map();

      try {
        if (!outil || !outil.lireTransport || !outil.poser) throw new Error('module absent');

        if (!this.etiquettes.has(id)) {
          const sep = b.url.indexOf('?') === -1 ? '?' : '&';
          const reponse = await fetch(b.url + sep + 'section_id=cm-etiquette', {
            headers: { Accept: 'text/html' },
          });
          if (!reponse.ok) throw new Error('HTTP ' + reponse.status);

          const donnees = outil.lireTransport(await reponse.text());
          if (!donnees) throw new Error('transport illisible');

          const chemin = (u) => String(u || '').split('?')[0].replace(/\/$/, '');
          if (chemin(donnees.url) !== chemin(b.url)) throw new Error('poignée discordante');

          this.etiquettes.set(id, donnees);
        }

        if (this.ficheOuverte !== id) return;
        outil.poser(this.fiche, this.etiquettes.get(id));
      } catch (erreur) {
        if (this.ficheOuverte !== id) return;

        if (corps) {
          corps.textContent = '';
          const pb = document.createElement('p');
          pb.className = 'cm-pmx__etiq-repli';
          pb.textContent =
            'L’étiquette n’a pas pu être chargée. Elle ne dit donc rien de ce que ce bonbon '
            + 'contient : tu la trouveras sur la page du produit et sur l’emballage.';
          corps.appendChild(pb);
          const a = document.createElement('a');
          a.className = 'cm-pmx__etiq-lien';
          a.href = b.url;
          a.textContent = 'Voir la fiche du produit';
          corps.appendChild(a);
        }
      }
    }
  }

  customElements.define('cm-pickmix', CmPickmix);
}
